/* DV-FIXED-PRODUCT-OPTION3-V1 */
/* DV-FIXED-STICKY-DISCOUNT-V1 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-dv-fixed-option3]';
  var mounted = new WeakMap();
  var aiRoomModalObserver = null;
  var AI_ROOM_MODAL_REPAIR_SENTINEL = 'DV-OPTION3-AI-ROOM-LIVE-NODE-V1';
  var GALLERY_LIGHTBOX_SENTINEL = 'DV-OPTION3-FULLSCREEN-GALLERY-V1';
  var ALERT_REQUEST_TIMEOUT_MS = 8000;
  // The public decision remains fail-closed, but a reserved ngrok tunnel can
  // need several seconds to wake or reconnect.  Do not turn that transient
  // transport delay into a customer-visible false failure: keep one bounded
  // 10-second window and retry only failed HTTP/JSON transports inside it.
  var ELIGIBILITY_REQUEST_TIMEOUT_MS = 10000;
  var ELIGIBILITY_RETRY_DELAYS_MS = [350, 900];

  function toInteger(value, fallback) {
    var number = Number(value);
    return Number.isSafeInteger(number) ? number : fallback;
  }

  function majorPriceToCents(value) {
    if (typeof value !== 'number' && typeof value !== 'string') return null;
    var raw = String(value).trim();
    if (!/^\d+(?:\.\d{1,2})?$/.test(raw)) return null;
    var number = Number(raw);
    if (!Number.isFinite(number) || number < 0) return null;
    var cents = Math.round(number * 100);
    return Number.isSafeInteger(cents) ? cents : null;
  }

  function validEvidenceHash(value) {
    return /^[a-f0-9]{64}$/i.test(String(value || ''));
  }

  function validIso(value) {
    return typeof value === 'string' && value.length >= 20 && Number.isFinite(Date.parse(value));
  }

  function inclusiveDayCount(from, through) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(from || '')) ||
        !/^\d{4}-\d{2}-\d{2}$/.test(String(through || ''))) return null;
    var left = Date.parse(String(from) + 'T00:00:00.000Z');
    var right = Date.parse(String(through) + 'T00:00:00.000Z');
    if (!Number.isFinite(left) || !Number.isFinite(right)) return null;
    var days = Math.round((right - left) / 86400000) + 1;
    return Number.isSafeInteger(days) && days > 0 ? days : null;
  }

  function clampQuantity(value) {
    var number = Math.floor(Number(value));
    return Number.isFinite(number) && number > 0 ? number : 1;
  }

  function money(cents) {
    var safe = Math.max(0, toInteger(cents, 0));
    return new Intl.NumberFormat('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(safe / 100) + ' TL';
  }

  function campaignEndText(algorithm, now) {
    if (!algorithm) return '';
    var end = Date.parse(algorithm.endAt || '');
    if (!Number.isFinite(end) || end <= now) return '';
    try {
      return 'Fırsat fiyatı ' + new Intl.DateTimeFormat('tr-TR', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Istanbul'
      }).format(new Date(end)) + ' tarihine kadar geçerli.';
    } catch (_) {
      return '';
    }
  }

  function campaignEndValue(algorithm, now) {
    if (!algorithm) return '';
    var end = Date.parse(algorithm.endAt || '');
    if (!Number.isFinite(end) || end <= now) return '';
    try {
      return new Intl.DateTimeFormat('tr-TR', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Istanbul'
      }).format(new Date(end));
    } catch (_) {
      return '';
    }
  }

  function selectedVariantUrl(variantId) {
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', String(variantId));
      return url;
    } catch (_) {
      return null;
    }
  }

  function percentage(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return '';
    return new Intl.NumberFormat('tr-TR', {
      minimumFractionDigits: Number.isInteger(number) ? 0 : 1,
      maximumFractionDigits: 2
    }).format(number);
  }

  function calculateDiscountedCents(priceCents, percent) {
    var basisPoints = Math.round(Number(percent) * 100);
    if (!Number.isSafeInteger(priceCents) || priceCents < 0) return null;
    if (!Number.isInteger(basisPoints) || basisPoints <= 0 || basisPoints >= 10000) return null;
    return Math.round(priceCents * (10000 - basisPoints) / 10000);
  }

  function validAlgorithm(variant, now) {
    var algorithm = variant && variant.algorithm;
    if (!algorithm || algorithm.schemaVersion !== 2 || algorithm.source !== 'deal-wave') return null;
    var evidence = algorithm.priceEvidence;
    var campaignEvidence = evidence && evidence.campaign;
    if (!validEvidenceHash(algorithm.evidenceHash) || !evidence || evidence.schemaVersion !== 1 ||
        evidence.source !== algorithm.source || evidence.timezone !== 'Europe/Istanbul') return null;
    if (!validEvidenceHash(evidence.evidenceHash) || evidence.rollingLowest !== null || !campaignEvidence || campaignEvidence.coverageComplete !== true) return null;
    if (campaignEvidence.kind !== 'campaign' || campaignEvidence.source !== 'shopify-admin-campaign-readback' ||
        campaignEvidence.timezone !== 'Europe/Istanbul' || campaignEvidence.claimEligible !== true ||
        !validEvidenceHash(campaignEvidence.evidenceHash)) return null;
    var base = majorPriceToCents(algorithm.basePrice);
    var sale = majorPriceToCents(algorithm.salePrice);
    var displayCompareAt = majorPriceToCents(algorithm.displayCompareAt);
    var percent = Number(algorithm.percent);
    var ruleNo = toInteger(algorithm.dealRuleNo, 0);
    var start = Date.parse(algorithm.startAt || '');
    var end = Date.parse(algorithm.endAt || '');
    var markerBarcode = String(algorithm.barcode || '').trim();
    var liveBarcode = String(variant && variant.barcode || '').trim();
    if (!algorithm.campaignId || !markerBarcode || markerBarcode !== liveBarcode || variant.available !== true) return null;
    if (base == null || sale == null || displayCompareAt == null || base <= sale || sale <= 0 || displayCompareAt <= sale) return null;
    if (ruleNo < 7000) return null;
    if (displayCompareAt !== variant.compareAtCents || sale !== variant.priceCents) return null;
    if (!Number.isFinite(percent) || percent < 1 || percent > 90) return null;
    if (!Number.isFinite(start) || !Number.isFinite(end) || start > now || now >= end) return null;
    var livePercent = Math.round((base - sale) * 100 / base);
    if (livePercent !== Math.round(percent)) return null;
    var evidenceCheckedAt = Date.parse(campaignEvidence.checkedAt || '');
    if (!Number.isFinite(evidenceCheckedAt) || evidenceCheckedAt < start || evidenceCheckedAt > now) return null;
    if (Math.round(Number(campaignEvidence.basePrice) * 100) !== base) return null;
    if (Math.round(Number(campaignEvidence.salePrice) * 100) !== sale) return null;
    if (Math.round(Number(campaignEvidence.percent)) !== livePercent) return null;
    var listEvidence = evidence.listPrice;
    var listPriceVerified = Boolean(listEvidence &&
      listEvidence.kind === 'listPrice' &&
      listEvidence.source === 'shopify-admin-list-price-readback' &&
      listEvidence.timezone === 'Europe/Istanbul' &&
      listEvidence.coverageComplete === true &&
      listEvidence.claimEligible === false &&
      validEvidenceHash(listEvidence.evidenceHash) &&
      validIso(listEvidence.checkedAt) &&
      Date.parse(listEvidence.checkedAt) >= start &&
      Date.parse(listEvidence.checkedAt) <= now &&
      majorPriceToCents(listEvidence.price) === displayCompareAt);
    if (!listPriceVerified) return null;

    var reference = evidence.preCampaignReference;
    if (reference != null) {
      var referenceDays = toInteger(reference.days, 0);
      if (reference.kind !== 'preCampaignReference' || reference.source !== 'shopify-admin-price-history' ||
          ![10, 30].includes(referenceDays) || toInteger(reference.coverageDays, 0) !== referenceDays ||
          reference.coverageComplete !== true || !validEvidenceHash(reference.evidenceHash) ||
          !validIso(reference.checkedAt) || Date.parse(reference.checkedAt) > now ||
          inclusiveDayCount(reference.coveredFrom, reference.coveredThrough) !== referenceDays ||
          majorPriceToCents(reference.price) == null || majorPriceToCents(reference.price) <= sale) return null;
    }

    return Object.assign({}, algorithm, {
      basePriceCents: base,
      salePriceCents: sale,
      displayCompareAtCents: displayCompareAt,
      listPriceVerified: listPriceVerified
    });
  }

  function exactOptionalPriceProof(method, variant, algorithm, allowedDays) {
    var contract = window.DVIndirim;
    if (!contract || typeof contract[method] !== 'function') return null;
    var proof;
    try {
      proof = method === 'rollingLowest'
        ? contract[method](variant.id, algorithm.salePriceCents)
        : contract[method]({ marker: variant.algorithm }, algorithm.salePriceCents);
    } catch (_) {
      return null;
    }
    var expectedType = method === 'rollingLowest' ? 'rollingLowest' : 'preCampaignReference';
    var days = toInteger(proof && proof.gun, 0);
    var priceCents = toInteger(proof && proof.kurus, 0);
    var invalidPrice = method === 'rollingLowest'
      ? priceCents < algorithm.salePriceCents
      : priceCents <= algorithm.salePriceCents;
    if (!proof || proof.tur !== expectedType || proof.kaynak !== 'shopify-admin-price-history' ||
        allowedDays.indexOf(days) === -1 || invalidPrice ||
        !validEvidenceHash(proof.evidenceHash)) return null;
    return { days: days, priceCents: priceCents, evidenceHash: String(proof.evidenceHash) };
  }

  function priceProofModel(variant, now) {
    var algorithm = validAlgorithm(variant, now);
    if (!algorithm) return null;
    var endValue = campaignEndValue(algorithm, now);
    if (!endValue) return null;
    return {
      basePriceCents: algorithm.basePriceCents,
      salePriceCents: algorithm.salePriceCents,
      percent: Math.round(Number(algorithm.percent)),
      endValue: endValue,
      preCampaign: exactOptionalPriceProof('preCampaignReference', variant, algorithm, [10, 30]),
      rollingLowest: exactOptionalPriceProof('rollingLowest', variant, algorithm, [3, 7, 14, 30])
    };
  }

  function validCartDecision(decision, now) {
    if (!decision || decision.ok !== true || decision.verified !== true || decision.eligible !== true) return null;
    if (decision.productKind !== 'standard') return null;
    if (!/^[a-f0-9]{12}$/.test(String(decision.ruleRevision || ''))) return null;
    var validUntil = Date.parse(decision.validUntil || '');
    if (!Number.isFinite(validUntil) || validUntil <= now) return null;
    var discount = decision.discount;
    if (!discount || discount.source !== 'shopify_automatic_basic' || discount.type !== 'percentage') return null;
    var value = Number(discount.value);
    if (!Number.isFinite(value) || value <= 0 || value >= 100) return null;
    if (!['all', 'collection', 'product', 'variant'].includes(discount.matchedScope)) return null;
    var combines = discount.combinesWith;
    if (!combines ||
        typeof combines.productDiscounts !== 'boolean' ||
        typeof combines.orderDiscounts !== 'boolean' ||
        typeof combines.shippingDiscounts !== 'boolean') return null;
    var minimum = discount.minimum;
    if (minimum && !['subtotal', 'quantity'].includes(minimum.type)) return null;
    return discount;
  }

  function validNoCartDecision(decision, now) {
    if (!decision || decision.ok !== true || decision.verified !== true || decision.eligible !== false) return false;
    if (decision.productKind !== 'standard') return false;
    var checkedAt = Date.parse(decision.checkedAt || '');
    var validUntil = Date.parse(decision.validUntil || '');
    return Number.isFinite(checkedAt) && checkedAt <= now &&
      Number.isFinite(validUntil) && validUntil > now;
  }

  function readConfig(root) {
    var element = root.querySelector('[data-dv-fixed-config]');
    if (!element) return null;
    try {
      var config = JSON.parse(element.textContent || '{}');
      if (!Array.isArray(config.variants) || !config.variants.length) return null;
      config.variants = config.variants.map(function (variant) {
        return Object.assign({}, variant, {
          id: String(variant.id || ''),
          priceCents: toInteger(variant.priceCents, 0),
          compareAtCents: toInteger(variant.compareAtCents, 0)
        });
      });
      return config;
    } catch (_) {
      return null;
    }
  }

  function query(root, selector) {
    return root.querySelector(selector);
  }

  function setHidden(element, hidden) {
    if (!element) return;
    element.hidden = Boolean(hidden);
    element.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  }

  function scrollExpandedRegion(element, block) {
    if (!element || typeof element.scrollIntoView !== 'function') return;
    var behavior = 'auto';
    try {
      if (!window.matchMedia || window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
        behavior = 'smooth';
      }
    } catch (_) {}
    window.setTimeout(function () {
      element.scrollIntoView({ behavior: behavior, block: block || 'nearest' });
      window.setTimeout(function () {
        var root = element.closest && element.closest(ROOT_SELECTOR);
        var sticky = root && root.querySelector('[data-dv-fixed-mobile-sticky]');
        if (!root || root.dataset.stickyVisible !== 'true' || !sticky) return;
        var elementBox = element.getBoundingClientRect();
        var stickyBox = sticky.getBoundingClientRect();
        var overlap = elementBox.bottom - (stickyBox.top - 16);
        if (overlap > 0) window.scrollBy({ top: Math.ceil(overlap), behavior: 'auto' });
      }, behavior === 'smooth' ? 450 : 32);
    }, 0);
  }

  function repairAiRoomModal() {
    var modal = document.getElementById('pbr-ai-modal');
    if (!modal) return false;
    if (modal.dataset.dvAiLiveNode === AI_ROOM_MODAL_REPAIR_SENTINEL) return true;

    var modalBody = modal.querySelector('.pbr-modal-body');
    var aiRoom = document.getElementById('ai-room-analyzer-v4');
    var trigger = document.querySelector('.pbr-item.pbr-ai');
    if (!modalBody || !aiRoom || !trigger || modal.contains(aiRoom)) return false;

    // product-badges-row.js copies innerHTML into the modal. That duplicate has
    // no upload/change handlers. Move the real, already-wired nodes instead.
    while (modalBody.firstChild) modalBody.removeChild(modalBody.firstChild);
    while (aiRoom.firstChild) modalBody.appendChild(aiRoom.firstChild);
    aiRoom.remove();

    modal.dataset.dvAiLiveNode = AI_ROOM_MODAL_REPAIR_SENTINEL;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Dolce AI Sisteminden Fikir Alın');
    modal.setAttribute('aria-hidden', 'true');

    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-controls', 'pbr-ai-modal');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-expanded', 'false');

    var closeButton = modal.querySelector('.pbr-modal-close');
    var overlay = modal.querySelector('.pbr-modal-overlay');
    if (closeButton) closeButton.setAttribute('aria-label', 'AI fikir panelini kapat');

    function markOpen() {
      modal.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      window.setTimeout(function () {
        var uploadButton = modal.querySelector('#ai-v4-upload-btn');
        if (uploadButton && typeof uploadButton.focus === 'function') uploadButton.focus();
      }, 0);
    }

    function markClosed() {
      modal.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      if (typeof trigger.focus === 'function') trigger.focus();
    }

    trigger.addEventListener('click', markOpen);
    trigger.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      trigger.click();
    });
    if (closeButton) closeButton.addEventListener('click', markClosed);
    if (overlay) overlay.addEventListener('click', markClosed);
    modal.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      modal.style.display = 'none';
      markClosed();
    });

    return true;
  }

  function ensureAiRoomModalRepair() {
    if (repairAiRoomModal() || typeof MutationObserver !== 'function' || aiRoomModalObserver) return;
    aiRoomModalObserver = new MutationObserver(function () {
      if (!repairAiRoomModal()) return;
      aiRoomModalObserver.disconnect();
      aiRoomModalObserver = null;
    });
    aiRoomModalObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  function normalizedSpecLabel(value) {
    return String(value || '')
      .toLocaleLowerCase('tr-TR')
      .replace(/[:\s]+$/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function cleanSpecValue(value) {
    return String(value || '').replace(/^[:\s-]+/, '').replace(/\s+/g, ' ').trim();
  }

  function extractDescriptionSpecs(html) {
    var values = {};
    if (!html || typeof DOMParser !== 'function') return values;
    try {
      var documentFragment = new DOMParser().parseFromString(String(html), 'text/html');
      documentFragment.querySelectorAll('li, p').forEach(function (node) {
        var strong = node.querySelector('strong');
        if (!strong) return;
        var label = normalizedSpecLabel(strong.textContent);
        var clone = node.cloneNode(true);
        clone.querySelectorAll('strong').forEach(function (item) { item.remove(); });
        var value = cleanSpecValue(clone.textContent);
        if (!value || value.length > 80 || values[label]) return;
        values[label] = value;
      });
    } catch (_) {
      return {};
    }
    return values;
  }

  function firstSpec(values, labels) {
    for (var index = 0; index < labels.length; index += 1) {
      var value = values[normalizedSpecLabel(labels[index])];
      if (value) return value;
    }
    return '';
  }

  // DV-PRIME-EXACT-SIZE-ALTERNATIVE-20260906: one read-only request; no price or cart action.
  function createPrimeSizeAlternative(owner) {
    var sourcePath = '/products/dolce-vita-hali-prime-8305-blend';
    var targetPath = '/products/dolce-vita-hali-prime-8308-palace';
    var maxAge = 120000, timeout = 3000, maxBytes = 131072;
    var requested = false, pending = null, cached = null, expiryTimer = null;
    var box = null, link = null, shownSize = null, leftPage = false;
    function sourceAllowed() {
      try {
        return String(owner.config.productId) === '7966209310936' &&
          owner.root.dataset.dvProductProfileContract === 'allow:v1:dolce_vita:fixed_rug:decision_guide_v1' &&
          owner.config.currency === 'TRY' && window.Shopify && window.Shopify.currency &&
          window.Shopify.currency.active === 'TRY' &&
          window.location.protocol === 'https:' && /^(www\.)?dolcevitahali\.com$/.test(window.location.hostname) &&
          window.location.pathname.replace(/\/$/, '') === sourcePath &&
          new URL(owner.config.canonicalUrl).origin === window.location.origin &&
          new URL(owner.config.canonicalUrl).pathname === sourcePath;
      } catch (_) { return false; }
    }
    if (!sourceAllowed() || !owner.nodes.sizeSummary || typeof AbortController !== 'function' || typeof TextDecoder !== 'function') return null;
    function size(value) {
      var match = typeof value === 'string' && value.trim().match(/^(\d{2,3})\s*[xX×]\s*(\d{2,3})$/);
      if (!match || Number(match[1]) < 50 || Number(match[2]) < 50) return null;
      return Number(match[1]) + 'x' + Number(match[2]);
    }
    function selectedSize() {
      var variant = owner.variant;
      return sourceAllowed() && owner.root.isConnected && !leftPage && !document.hidden &&
        variant && variant.available === false && owner.variants.get(String(variant.id)) === variant &&
        owner.root.dataset.variantId === String(variant.id) ? size(variant.title) : null;
    }
    function hide() {
      shownSize = null;
      if (box) { box.hidden = true; link.removeAttribute('href'); }
    }
    function usable() {
      var now = Date.now();
      return cached && now >= cached.observedAt && now < cached.validUntil;
    }
    function render() {
      var key = selectedSize(), target = usable() && key && cached.variants[key];
      if (!target || target.available !== true) { hide(); return; }
      if (!box) {
        box = document.createElement('p');
        box.setAttribute('data-dv-prime-size-alternative', '');
        box.setAttribute('aria-live', 'polite');
        box.style.margin = '8px 0'; box.style.fontSize = '14px'; box.style.lineHeight = '1.4';
        box.appendChild(document.createTextNode('Farklı bir Prime modeli: '));
        link = document.createElement('a');
        link.style.textDecoration = 'underline';
        link.addEventListener('click', function (event) {
          if (!usable() || !shownSize || selectedSize() !== shownSize) {
            event.preventDefault(); event.stopImmediatePropagation(); hide();
          }
        }, true);
        box.appendChild(link);
        owner.nodes.sizeSummary.insertAdjacentElement('afterend', box);
      }
      shownSize = key;
      link.textContent = 'Prime 8308 Palace · ' + key.replace('x', '×') + ' cm stokta — modeli incele';
      link.href = targetPath + '?variant=' + target.id;
      box.hidden = false;
    }
    function validateProduct(product) {
      if (!product || String(product.id) !== '7972943167704' ||
          product.handle !== targetPath.slice('/products/'.length) ||
          product.title !== 'Dolce Vita Halı Prime 8308 Palace Salon Halısı' ||
          product.vendor !== 'Dolce Vita Halı' || product.type !== '' ||
          (product.currency !== undefined && product.currency !== 'TRY') ||
          !Array.isArray(product.options) || product.options.length !== 1 ||
          product.options[0].name !== 'Boyut' || product.options[0].position !== 1 ||
          !Array.isArray(product.variants) || !product.variants.length || product.variants.length > 20 ||
          !Array.isArray(product.options[0].values) || product.options[0].values.length !== product.variants.length) throw Error('INVALID_PRODUCT');
      var variants = Object.create(null), ids = new Set(), values = new Set(product.options[0].values.map(size));
      if (values.has(null) || values.size !== product.variants.length) throw Error('INVALID_SIZES');
      product.variants.forEach(function (variant) {
        var key = size(variant.title), id = String(variant.id);
        if (!key || !values.has(key) || variants[key] || !/^\d{10,16}$/.test(id) || !Number.isSafeInteger(Number(id)) || ids.has(id) ||
            variant.option1 !== variant.title || variant.option2 != null || variant.option3 != null ||
            !Array.isArray(variant.options) || variant.options.length !== 1 || variant.options[0] !== variant.title ||
            typeof variant.available !== 'boolean' || variant.requires_shipping !== true || variant.requires_selling_plan !== false) throw Error('INVALID_VARIANT');
        ids.add(id); variants[key] = {id: id, available: variant.available};
      });
      return variants;
    }
    async function readJson(response, controller, deadline) {
      var length = response.headers.get('content-length');
      if (length != null && (!/^\d+$/.test(length) || Number(length) > maxBytes)) throw Error('BODY_LIMIT');
      if (!response.body || typeof response.body.getReader !== 'function') throw Error('BODY_MISSING');
      var reader = response.body.getReader(), decoder = new TextDecoder('utf-8', {fatal:true}), bytes = 0, body = '';
      try {
        while (true) {
          if (controller.signal.aborted || Date.now() >= deadline) throw Error('DEADLINE');
          var part = await reader.read();
          if (controller.signal.aborted || Date.now() >= deadline) throw Error('DEADLINE');
          if (part.done) break;
          bytes += part.value.byteLength;
          if (bytes > maxBytes) throw Error('BODY_LIMIT');
          body += decoder.decode(part.value, {stream:true});
        }
        return JSON.parse(body + decoder.decode());
      } catch (error) { controller.abort(); try { await reader.cancel(); } catch (_) {} throw error; }
      finally { reader.releaseLock(); }
    }
    async function request() {
      requested = true;
      var observedAt = Date.now(), deadline = observedAt + timeout, controller = new AbortController();
      pending = controller;
      var timer = window.setTimeout(function () { controller.abort(); hide(); }, timeout);
      try {
        var url = new URL(targetPath + '.js', window.location.origin).toString();
        var response = await fetch(url, {method:'GET', credentials:'omit', cache:'no-store', redirect:'error', headers:{Accept:'application/json'}, signal:controller.signal});
        if (!response.ok || response.status !== 200 || response.redirected || response.url !== url || controller.signal.aborted || Date.now() >= deadline) throw Error('RESPONSE_INVALID');
        var serverAt = Date.parse(response.headers.get('date') || ''), age = response.headers.get('age');
        if (!Number.isFinite(serverAt) || serverAt > Date.now() + 5000 || (age != null && !/^\d+$/.test(age))) throw Error('FRESHNESS_INVALID');
        var validUntil = Math.min(observedAt + maxAge, serverAt + maxAge, Date.now() + maxAge - Number(age || 0) * 1000);
        if (validUntil <= Date.now()) throw Error('RESPONSE_STALE');
        var product = await readJson(response, controller, deadline);
        if (pending !== controller || controller.signal.aborted || Date.now() >= deadline || Date.now() < observedAt || Date.now() >= validUntil) throw Error('RESPONSE_STALE');
        cached = {observedAt:observedAt, validUntil:validUntil, variants:validateProduct(product)};
        expiryTimer = window.setTimeout(function () { hide(); }, Math.max(0, validUntil-Date.now()));
        render(); // Re-read the current selection; the initiating size may have changed.
      } catch (_) { cached = null; hide(); }
      finally { window.clearTimeout(timer); if (pending === controller) pending = null; }
    }
    function update() {
      hide();
      if (!selectedSize()) return;
      if (usable()) { render(); return; }
      if (!requested) request(); // One GET per page. No retry, automatic refresh or polling.
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden) hide(); else update(); });
    window.addEventListener('pagehide', function () { leftPage = true; hide(); if (pending) pending.abort(); });
    window.addEventListener('pageshow', function () { leftPage = false; update(); });
    return {update:update};
  }


  function Option3(root) {
    this.root = root;
    this.config = readConfig(root);
    this.form = this.config ? document.getElementById(root.dataset.productFormId || '') : null;
    this.variants = new Map();
    this.variant = null;
    this.cartDiscount = null;
    this.eligibilityState = 'idle';
    this.eligibilityCache = new Map();
    this.eligibilityRequest = null;
    this.eligibilitySequence = 0;
    this.lastButtonClickAt = 0;
    this.submitLocked = false;
    this.submitTimer = null;

    if (!this.config) return;
    this.config.variants.forEach(function (variant) {
      if (variant.id) this.variants.set(variant.id, variant);
    }, this);

    this.nodes = {
      sku: query(root, '[data-dv-fixed-sku]'),
      pricing: query(root, '[data-dv-fixed-pricing]'),
      listLabel: query(root, '[data-dv-fixed-list-label]'),
      listPrice: query(root, '[data-dv-fixed-list-price]'),
      listMetric: query(root, '[data-dv-fixed-list-metric]'),
      currentLabel: query(root, '[data-dv-fixed-current-label]'),
      currentPrice: query(root, '[data-dv-fixed-current-price]'),
      savingMetric: query(root, '[data-dv-fixed-saving-metric]'),
      savingLabel: query(root, '[data-dv-fixed-saving-metric] > span'),
      savingAmount: query(root, '[data-dv-fixed-saving-amount]'),
      savingSeparator: query(root, '[data-dv-fixed-saving-separator]'),
      savingPercent: query(root, '[data-dv-fixed-saving-percent]'),
      badges: query(root, '[data-dv-fixed-badges]'),
      dealBadge: query(root, '[data-dv-fixed-deal-badge]'),
      cartBadge: query(root, '[data-dv-fixed-cart-badge]'),
      campaignEnd: query(root, '[data-dv-fixed-campaign-end]'),
      priceProof: query(root, '[data-dv-fixed-price-proof]'),
      priceProofToggle: query(root, '[data-dv-fixed-price-proof-toggle]'),
      priceProofPanel: query(root, '[data-dv-fixed-price-proof-panel]'),
      priceProofIntro: query(root, '[data-dv-fixed-price-proof-intro]'),
      priceProofBaseLabel: query(root, '[data-dv-fixed-price-proof-base-label]'),
      priceProofSaleLabel: query(root, '[data-dv-fixed-price-proof-sale-label]'),
      priceProofBase: query(root, '[data-dv-fixed-price-proof-base]'),
      priceProofSale: query(root, '[data-dv-fixed-price-proof-sale]'),
      priceProofPercent: query(root, '[data-dv-fixed-price-proof-percent]'),
      priceProofEnd: query(root, '[data-dv-fixed-price-proof-end]'),
      priceProofEndRow: query(root, '[data-dv-fixed-price-proof-end-row]'),
      priceProofPreRow: query(root, '[data-dv-fixed-price-proof-pre-row]'),
      priceProofPreLabel: query(root, '[data-dv-fixed-price-proof-pre-label]'),
      priceProofPrePrice: query(root, '[data-dv-fixed-price-proof-pre-price]'),
      priceProofRollingRow: query(root, '[data-dv-fixed-price-proof-rolling-row]'),
      priceProofRollingLabel: query(root, '[data-dv-fixed-price-proof-rolling-label]'),
      priceProofRollingPrice: query(root, '[data-dv-fixed-price-proof-rolling-price]'),
      stackNote: query(root, '[data-dv-fixed-stack-note]'),
      cartResult: query(root, '[data-dv-fixed-cart-result]'),
      cartTotal: query(root, '[data-dv-fixed-cart-total]'),
      cartExtra: query(root, '[data-dv-fixed-cart-extra]'),
      totalSaving: query(root, '[data-dv-fixed-total-saving]'),
      conditional: query(root, '[data-dv-fixed-conditional]'),
      cartVerification: query(root, '[data-dv-fixed-cart-verification]'),
      cartVerificationMessage: query(root, '[data-dv-fixed-cart-verification-message]'),
      cartRetry: query(root, '[data-dv-fixed-cart-retry]'),
      installmentMonthly: query(root, '[data-dv-fixed-installment-monthly]'),
      priceInstallment: query(root, '[data-dv-fixed-price-installment]'),
      installments: query(root, '[data-dv-fixed-installments]'),
      specs: query(root, '[data-dv-fixed-specs]'),
      specsGrid: query(root, '[data-dv-fixed-specs-grid]'),
      sizeSummary: query(root, '[data-dv-fixed-size-summary]'),
      variants: query(root, '.dv-fixed-option3__variants'),
      sizeTitle: query(root, '[data-dv-fixed-size-title]'),
      sizeStock: query(root, '[data-dv-fixed-size-stock]'),
      sizeToggle: query(root, '[data-dv-fixed-size-toggle]'),
      watchVideos: query(root, '[data-dv-fixed-watch-videos]'),
      roomView: query(root, '[data-dv-fixed-room-view]'),
      whatsapp: query(root, '[data-dv-fixed-whatsapp]'),
      stickySummary: query(root, '[data-dv-fixed-sticky-summary]'),
      stickySize: query(root, '[data-dv-fixed-sticky-size]'),
      stickyDeal: query(root, '[data-dv-fixed-sticky-deal]'),
      stickyListPrice: query(root, '[data-dv-fixed-sticky-list-price]'),
      stickyDiscount: query(root, '[data-dv-fixed-sticky-discount]'),
      stickyPrice: query(root, '[data-dv-fixed-sticky-price]'),
      stickyButton: query(root, '[data-dv-fixed-sticky-button]'),
      stickyActions: query(root, '[data-dv-fixed-sticky-actions]'),
      stickyAlert: query(root, '[data-dv-fixed-sticky-alert]'),
      alert: query(root, '[data-dv-fixed-alert]'),
      alertToggle: query(root, '[data-dv-fixed-alert-toggle]'),
      alertPanel: query(root, '[data-dv-fixed-alert-panel]'),
      alertTitle: query(root, '[data-dv-fixed-alert-title]'),
      alertHint: query(root, '[data-dv-fixed-alert-hint]'),
      alertEmail: query(root, '[data-dv-fixed-alert-email]'),
      alertConsent: query(root, '[data-dv-fixed-alert-consent]'),
      alertSubmit: query(root, '[data-dv-fixed-alert-submit]'),
      alertStatus: query(root, '[data-dv-fixed-alert-status]'),
      productSchema: query(root, '[data-dv-fixed-product-schema]'),
      quantity: query(root, 'input[name="quantity"]'),
      buyButton: query(root, 'button[name="add"]')
    };
    this.buyText = this.nodes.buyButton &&
      (this.nodes.buyButton.querySelector('.hdt-btn-atc_text') || this.nodes.buyButton.querySelector('[data-atc-text]'));
    if (!this.buyText) this.buyText = this.nodes.buyButton;
  }

  Option3.prototype.init = function () {
    if (!this.config) {
      this.root.dataset.state = 'config-error';
      return;
    }
    document.documentElement.classList.add('dv-fixed-option3-page');
    var firstBodyNode = document.body && document.body.firstChild;
    if (firstBodyNode && firstBodyNode.nodeType === 3 && firstBodyNode.nodeValue.indexOf('\uFEFF') !== -1) {
      firstBodyNode.nodeValue = firstBodyNode.nodeValue.replace(/\uFEFF/g, '');
      if (!firstBodyNode.nodeValue.trim()) firstBodyNode.remove();
    }
    var headerLogo = document.querySelector('header .hdt-logo');
    var headerRow = headerLogo && headerLogo.parentElement && headerLogo.parentElement.parentElement;
    if (headerRow) headerRow.classList.add('dv-fixed-option3-header-row');
    this.normalizeLegacyTrustCopy();
    this.initGalleryParity();
    this.initGalleryLightbox();
    this.initMediaActions();
    this.initStoryActions();
    var self = this;
    window.setTimeout(function () {
      self.initGalleryParity();
      self.initGalleryLightbox();
      self.initMediaActions();
      self.normalizeLegacyTrustCopy();
    }, 800);
    window.setTimeout(function () { self.normalizeLegacyTrustCopy(); }, 1800);
    this.decorateVariants();
    this.renderSpecs();
    var reviewControl = Array.prototype.slice.call(document.querySelectorAll('a, button')).find(function (node) {
      return String(node.textContent || '').trim() === 'İlk yorumu siz yazın';
    });
    if (reviewControl) reviewControl.textContent = 'Bu üründe henüz yorum yok';
    this.bind();
    this.initStickyVisibility();
    this.primeSizeAlternative = createPrimeSizeAlternative(this);
    var initial = String(this.root.dataset.selectedVariantId || this.config.selectedVariantId || '');
    var initialVariant = this.variants.get(initial);
    if (!initialVariant) {
      this.root.dataset.state = 'variant-config-error';
      return;
    }
    this.selectVariant(initialVariant, 'initial');
    this.bindCouponDisplayRefresh();
    window.addEventListener('load', function () {
      if (self.variant) self.renderPriceProof(self.variant, Date.now());
    }, { once: true });
    this.root.dataset.state = 'ready';
  };

  Option3.prototype.closePriceProof = function () {
    if (this.nodes.priceProofPanel) setHidden(this.nodes.priceProofPanel, true);
    if (this.nodes.priceProofToggle) this.nodes.priceProofToggle.setAttribute('aria-expanded', 'false');
  };

  Option3.prototype.renderPriceProof = function (variant, now) {
    var model = priceProofModel(variant, now);
    if (!this.nodes.priceProof) return;
    var completeSurface = this.nodes.priceProofToggle && this.nodes.priceProofPanel &&
      this.nodes.priceProofBase && this.nodes.priceProofSale && this.nodes.priceProofPercent &&
      this.nodes.priceProofEnd && this.nodes.priceProofPreRow && this.nodes.priceProofPreLabel &&
      this.nodes.priceProofPrePrice && this.nodes.priceProofRollingRow &&
      this.nodes.priceProofRollingLabel && this.nodes.priceProofRollingPrice;
    if (!completeSurface) {
      setHidden(this.nodes.priceProof, true);
      return;
    }
    if (!model) {
      this.closePriceProof();
      setHidden(this.nodes.priceProof, true);
      this.root.removeAttribute('data-price-proof-state');
      return;
    }

    this.nodes.priceProofBase.textContent = money(model.basePriceCents);
    this.nodes.priceProofSale.textContent = money(model.salePriceCents);
    this.nodes.priceProofPercent.textContent = '%' + percentage(model.percent);
    this.nodes.priceProofEnd.textContent = model.endValue;
    setHidden(this.nodes.priceProofEndRow, false);
    if (this.nodes.priceProofIntro) {
      this.nodes.priceProofIntro.textContent = 'Seçili ebatın doğrulanmış kampanya fiyatı:';
    }
    if (this.nodes.priceProofBaseLabel) {
      this.nodes.priceProofBaseLabel.textContent = 'Kampanya referansı';
    }
    if (this.nodes.priceProofSaleLabel) {
      this.nodes.priceProofSaleLabel.textContent = 'Fırsat fiyatı';
    }

    setHidden(this.nodes.priceProofPreRow, !model.preCampaign);
    if (model.preCampaign) {
      this.nodes.priceProofPreLabel.textContent = 'İndirimden önceki ' + model.preCampaign.days + ' günün en düşük fiyatı';
      this.nodes.priceProofPrePrice.textContent = money(model.preCampaign.priceCents);
    } else {
      this.nodes.priceProofPreLabel.textContent = '';
      this.nodes.priceProofPrePrice.textContent = '';
    }

    setHidden(this.nodes.priceProofRollingRow, !model.rollingLowest);
    if (model.rollingLowest) {
      this.nodes.priceProofRollingLabel.textContent = 'Son ' + model.rollingLowest.days + ' günün en düşük fiyatı';
      this.nodes.priceProofRollingPrice.textContent = money(model.rollingLowest.priceCents);
    } else {
      this.nodes.priceProofRollingLabel.textContent = '';
      this.nodes.priceProofRollingPrice.textContent = '';
    }

    setHidden(this.nodes.priceProof, false);
    this.root.dataset.priceProofState = 'verified-algorithm';
  };

  Option3.prototype.renderSpecs = function () {
    if (!this.nodes.specs || !this.nodes.specsGrid) return;
    var source = extractDescriptionSpecs(this.config.descriptionHtml);
    var features = this.config.features && typeof this.config.features === 'object'
      ? this.config.features
      : {};
    function verifiedValue(value) {
      if (Array.isArray(value)) {
        return value.map(function (item) { return String(item || '').trim(); }).filter(Boolean).join(', ');
      }
      return value == null ? '' : String(value).trim();
    }
    var yarn = verifiedValue(features.material);
    var pile = verifiedValue(features.pile);
    var backing = verifiedValue(features.backing);
    var shape = verifiedValue(features.shape);
    var rooms = verifiedValue(features.rooms);
    var custom = this.config.customSize && this.config.customSize.exact === true;
    var items = [];
    if (yarn) items.push({ label: 'İplik', value: yarn });
    if (pile) items.push({ label: 'Hav', value: pile });
    if (backing) items.push({ label: 'Taban', value: backing });
    if (shape) items.push({ label: 'Şekil', value: shape });
    if (rooms) items.push({ label: 'Kullanım alanı', value: rooms });
    if (features.robotVacuum === true) items.push({ label: 'Robot süpürge', value: 'Uygun' });
    if (custom && this.config.customSize.range) {
      items.push({ label: 'Özel ölçü', value: String(this.config.customSize.range) });
    }
    if (!items.length) {
      setHidden(this.nodes.specs, true);
      return;
    }
    this.nodes.specsGrid.textContent = '';
    items.slice(0, 6).forEach(function (item) {
      var card = document.createElement('div');
      var term = document.createElement('dt');
      var description = document.createElement('dd');
      term.textContent = item.label;
      description.textContent = item.value;
      card.appendChild(term);
      card.appendChild(description);
      this.nodes.specsGrid.appendChild(card);
    }, this);
    setHidden(this.nodes.specs, false);
    this.renderFeatureStrip(items, features, backing);
  };

  Option3.prototype.renderFeatureStrip = function (items, features, backing) {
    var productId = String(this.config && this.config.productId || this.root.getAttribute('data-product-id') || '');
    var strip = productId
      ? document.querySelector('[data-dv-fixed-feature-strip][data-product-id="' + productId + '"]')
      : null;
    if (!strip) return;
    var values = {
      yarn: features && features.material ? String(features.material).trim() : '',
      pile: features && features.pile ? String(features.pile).trim() : '',
      backing: backing || '',
      robot: features && features.robotVacuum === true ? 'Uygun' : '',
      custom: this.config.customSize && this.config.customSize.range ? String(this.config.customSize.range) : 'Hazır ebatlar'
    };
    strip.querySelectorAll('[data-dv-fixed-feature]').forEach(function (node) {
      var value = query(node, '[data-dv-fixed-feature-value]');
      var key = node.getAttribute('data-dv-fixed-feature');
      var verified = values[key] || '';
      setHidden(node, !verified);
      if (value) value.textContent = verified;
    });
    setHidden(strip, !strip.querySelector('[data-dv-fixed-feature]:not([hidden])'));
  };

  /* DV-OPTION3-NATURAL-TRUST-COPY-V1 */
  Option3.prototype.normalizeLegacyTrustCopy = function () {
    var productId = String(this.config && this.config.productId || this.root.getAttribute('data-product-id') || '');
    var reviewSection = productId
      ? document.querySelector('[data-dv-review-section][data-product-id="' + productId + '"]')
      : null;
    var eyebrow = reviewSection && query(reviewSection, '.dv-yrm__eyebrow');
    if (!eyebrow) return;
    var current = String(eyebrow.textContent || '').trim().toLocaleUpperCase('tr-TR');
    if (current === 'GERÇEK MÜŞTERİ DENEYİMLERİ' || current === 'MÜŞTERİ DENEYİMLERİ') {
      eyebrow.textContent = 'EVİNDE GÖRENLER ANLATIYOR';
    }
  };

  Option3.prototype.initStoryActions = function () {
    var productId = String(this.config && this.config.productId || this.root.getAttribute('data-product-id') || '');
    var productHandle = String(this.root.getAttribute('data-product-handle') || '');
    if (!productId) return;
    var story = document.querySelector('[data-dv-fixed-story][data-product-id="' + productId + '"]');
    if (!story || String(story.getAttribute('data-product-handle') || '') !== productHandle) return;
    if (story.getAttribute('data-actions-bound') === 'true') return;
    story.setAttribute('data-actions-bound', 'true');
    var video = query(story, '[data-dv-fixed-story-video]');
    var room = query(story, '[data-dv-fixed-story-room]');
    var review = query(story, '[data-dv-fixed-story-review]');
    var rating = review && query(review, '[data-dv-fixed-story-rating]');
    var reviewCount = review && query(review, '[data-dv-fixed-story-review-count]');
    var photos = query(story, '[data-dv-fixed-story-photos]');
    var photoCount = photos && query(photos, '[data-dv-fixed-story-photo-count]');
    var detailTrigger = query(story, '[data-dv-fixed-story-detail-trigger]');
    var self = this;
    if (video) video.addEventListener('click', function () { self.openProductVideo(); });
    if (room) room.addEventListener('click', function () { self.openRoomView(); });
    /* DV-OPTION3-TEXTURE-LIGHTBOX-V1 */
    if (detailTrigger) {
      var storyDetailMediaId = String(story.getAttribute('data-detail-media-id') || '');
      var triggerDetailMediaId = String(detailTrigger.getAttribute('data-media-id') || '');
      var exactDetailMediaAvailable = this.readGalleryMedia().some(function (item) {
        return String(item.id) === storyDetailMediaId && item.type === 'image';
      });
      if (!storyDetailMediaId || triggerDetailMediaId !== storyDetailMediaId || !exactDetailMediaAvailable) {
        detailTrigger.hidden = true;
      } else {
        detailTrigger.addEventListener('click', function () {
          var exactDetailStillAvailable = self.readGalleryMedia().some(function (item) {
            return String(item.id) === storyDetailMediaId && item.type === 'image';
          });
          if (!exactDetailStillAvailable) {
            detailTrigger.hidden = true;
            return;
          }
          self.openGalleryLightbox(storyDetailMediaId, detailTrigger);
        });
      }
    }
    function hydrateReviewProof() {
      if (!review || !rating || !reviewCount) return;
      var proof = document.querySelector('.dv-yrm-top[data-product-id="' + productId + '"][data-product-handle="' + CSS.escape(productHandle) + '"]');
      var scoreNode = proof && query(proof, 'strong');
      var countNode = proof && query(proof, '.dv-yrm-top__count');
      var score = scoreNode ? Number(String(scoreNode.textContent || '').replace(',', '.')) : 0;
      var countMatch = countNode && String(countNode.textContent || '').trim().match(/^(\d+)\s+değerlendirme$/i);
      var count = countMatch ? Number(countMatch[1]) : 0;
      if (!(score > 0 && score <= 5 && Number.isInteger(count) && count > 0)) return;
      rating.textContent = score.toFixed(1) + '/5';
      reviewCount.textContent = count + ' değerlendirme';
      setHidden(review, false);
      var photoNode = query(proof, '.dv-yrm-top__photos');
      var photoMatch = photoNode && String(photoNode.textContent || '').trim().match(/^(\d+)\s+müşteri fotoğrafı$/i);
      var photoTotal = photoMatch ? Number(photoMatch[1]) : 0;
      if (photos && photoCount && Number.isInteger(photoTotal) && photoTotal > 0) {
        photoCount.textContent = photoTotal + ' fotoğraf';
        setHidden(photos, false);
      }
    }
    hydrateReviewProof();
    [500, 1500].forEach(function (delay) { window.setTimeout(hydrateReviewProof, delay); });
  };

  Option3.prototype.initMediaActions = function () {
    var productSection = this.root.closest('.hdt-main-product');
    var media = productSection && query(productSection, '.hdt-product-media');
    var host = media && (media.closest('.hdt-product-media-wrapp') || media.parentElement || media);
    if (!media || !host || query(host, '[data-dv-fixed-media-actions]')) return;
    var slides = Array.prototype.slice.call(media.querySelectorAll('.hdt-slider__slide'));
    var videoCount = slides.filter(function (slide) {
      return slide.matches('[data-media-type="video"], [data-media-type="external_video"]') || Boolean(slide.querySelector('video, iframe'));
    }).length;
    var imageCount = slides.filter(function (slide) {
      return slide.matches('[data-media-type="image"]') || Boolean(slide.querySelector('img'));
    }).length;
    var roomViewUrl = this.config.media && this.config.media.roomViewUrl
      ? String(this.config.media.roomViewUrl).trim()
      : '';
    var actions = document.createElement('div');
    actions.className = 'dv-fixed-option3__media-actions';
    actions.setAttribute('data-dv-fixed-media-actions', '');
    var compact = document.createElement('div');
    compact.className = 'dv-fixed-option3__media-compact';
    compact.textContent = imageCount + ' ürün görseli' + (videoCount ? ' · ' + videoCount + ' video' : '');
    actions.appendChild(compact);
    var video = null;
    var room = null;
    if (videoCount) {
      video = document.createElement('button');
      video.type = 'button';
      video.setAttribute('data-dv-fixed-media-video', '');
      video.textContent = 'Video izleyin';
      actions.appendChild(video);
    }
    if (roomViewUrl) {
      room = document.createElement('button');
      room.type = 'button';
      room.setAttribute('data-dv-fixed-media-room', '');
      room.textContent = 'Odanda gör';
      actions.appendChild(room);
    }
    actions.dataset.actionCount = String((video ? 1 : 0) + (room ? 1 : 0));
    host.appendChild(actions);
    if (this.nodes.watchVideos) {
      setHidden(this.nodes.watchVideos, !videoCount);
      if (videoCount && this.nodes.watchVideos.firstChild) this.nodes.watchVideos.firstChild.nodeValue = 'Video izleyin ';
    }
    if (this.nodes.roomView) setHidden(this.nodes.roomView, !roomViewUrl);
    var self = this;
    if (video) video.addEventListener('click', function () { self.openProductVideo(); });
    if (room) room.addEventListener('click', function () { self.openRoomView(); });
  };

  Option3.prototype.openProductVideo = function () {
    var productSection = this.root.closest('.hdt-main-product');
    var videoSlide = productSection && query(productSection, '.hdt-slider__slide[data-media-type="video"], .hdt-slider__slide[data-media-type="external_video"]');
    if (!videoSlide && productSection) videoSlide = query(productSection, 'video, iframe');
    if (!videoSlide) return;
    var thumb = productSection.querySelector('[data-media-id="' + (videoSlide.getAttribute && videoSlide.getAttribute('data-media-id') || '') + '"] button, [data-media-id="' + (videoSlide.getAttribute && videoSlide.getAttribute('data-media-id') || '') + '"]');
    if (thumb && typeof thumb.click === 'function') thumb.click();
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    videoSlide.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
    var nativeVideo = videoSlide.matches && videoSlide.matches('video') ? videoSlide : query(videoSlide, 'video');
    if (nativeVideo && typeof nativeVideo.play === 'function') nativeVideo.play().catch(function () {});
  };

  Option3.prototype.openRoomView = function () {
    var candidates = Array.prototype.slice.call(document.querySelectorAll('button, a'));
    var control = candidates.find(function (node) {
      return /halıyı odanda gör|odanda gör/i.test(String(node.textContent || '').trim()) && !node.matches('[data-dv-fixed-room-view], [data-dv-fixed-media-room], [data-dv-fixed-story-room]');
    });
    if (control && typeof control.click === 'function') {
      control.click();
      return;
    }
    var roomViewUrl = this.config.media && this.config.media.roomViewUrl
      ? String(this.config.media.roomViewUrl).trim()
      : '';
    if (!roomViewUrl) return;
    var mobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    if (mobile) window.location.assign(roomViewUrl);
    else window.open(roomViewUrl, '_blank', 'noopener,noreferrer');
  };

  Option3.prototype.openWhatsapp = function () {
    var link = document.querySelector('#dvb-wa-float, a[href*="wa.me"], a[href*="whatsapp"]');
    if (link && typeof link.click === 'function') link.click();
  };

  Option3.prototype.initStickyVisibility = function () {
    var sticky = query(this.root, '[data-dv-fixed-mobile-sticky]');
    if (!sticky) return;
    if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
      // The approved compact mobile layout intentionally hides the in-flow buy
      // block, so the fixed purchase control must never depend on observing it.
      this.root.dataset.stickyVisible = 'true';
      return;
    }
    if (!this.nodes.buyButton || typeof IntersectionObserver !== 'function') return;
    var self = this;
    var hasSeenPrimary = false;
    this.root.dataset.stickyVisible = 'false';
    this.stickyObserver = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (!entry) return;
      if (entry.isIntersecting) hasSeenPrimary = true;
      self.root.dataset.stickyVisible = hasSeenPrimary && !entry.isIntersecting ? 'true' : 'false';
    }, { threshold: 0.15 });
    this.stickyObserver.observe(this.nodes.buyButton);
  };

  Option3.prototype.initGalleryParity = function () {
    var productSection = this.root.closest('.hdt-main-product');
    var media = productSection && query(productSection, '.hdt-product-media');
    var container = media && query(media, '.hdt-product-media__main .hdt-slider__container');
    if (!media || !container) return;
    if (this.galleryContainer === container) return;
    if (this.galleryObserver) this.galleryObserver.disconnect();
    this.galleryContainer = container;

    var slides = Array.prototype.slice.call(container.querySelectorAll('.hdt-slider__slide'));
    var current = query(media, '.hdt-slider-counter--current');
    var total = query(media, '.hdt-slider-counter--total');
    var previous = query(media, '.hdt-product-media__main .hdt-slider__button--prev');
    var next = query(media, '.hdt-product-media__main .hdt-slider__button--next');
    if (!slides.length) return;

    var thumbArea = query(media, '.hdt-product-media__thumb');
    var thumbnailHost = thumbArea && query(thumbArea, 'hdt-slider-thumb');
    var thumbnails = thumbArea
      ? Array.prototype.slice.call(thumbArea.querySelectorAll('.hdt-thumbnail__media[data-media-id]'))
      : [];
    var controlledGalleryId = thumbnailHost && thumbnailHost.getAttribute('aria-controls');
    thumbnails.forEach(function (thumbnail, thumbnailIndex) {
      var mediaType = String(thumbnail.getAttribute('data-media-type') || 'image');
      if (!thumbnail.matches('button, a[href]')) {
        thumbnail.setAttribute('role', 'button');
        if (!thumbnail.hasAttribute('tabindex')) thumbnail.setAttribute('tabindex', '0');
      }
      if (!thumbnail.hasAttribute('aria-label')) {
        thumbnail.setAttribute(
          'aria-label',
          String(thumbnailIndex + 1) + '. ' + (mediaType === 'video' || mediaType === 'external_video' ? 'ürün videosunu' : 'ürün görselini') + ' göster'
        );
      }
      if (controlledGalleryId && !thumbnail.hasAttribute('aria-controls')) {
        thumbnail.setAttribute('aria-controls', controlledGalleryId);
      }
      if (thumbnail.dataset.dvFixedKeyboardBound !== 'true') {
        thumbnail.dataset.dvFixedKeyboardBound = 'true';
        thumbnail.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          thumbnail.click();
        });
      }
    });
    var dots = thumbArea && query(thumbArea, '.dv-fixed-option3__gallery-dots');
    if (thumbArea && !dots) {
      dots = document.createElement('div');
      dots.className = 'dv-fixed-option3__gallery-dots';
      dots.setAttribute('aria-hidden', 'true');
      slides.forEach(function () {
        var dot = document.createElement('i');
        dot.className = 'dv-fixed-option3__gallery-dot';
        dots.appendChild(dot);
      });
      thumbArea.appendChild(dots);
    }
    var dotItems = dots ? Array.prototype.slice.call(dots.children) : [];

    function transformX() {
      var inline = String(container.style.transform || '');
      var translated = inline.match(/translate3d\(\s*(-?[\d.]+)px/i) || inline.match(/translateX\(\s*(-?[\d.]+)px/i);
      if (translated) return Number(translated[1]) || 0;
      var computed = window.getComputedStyle(container).transform;
      if (!computed || computed === 'none') return 0;
      var matrix = computed.match(/matrix(?:3d)?\(([^)]+)\)/);
      if (!matrix) return 0;
      var values = matrix[1].split(',').map(Number);
      return values.length === 16 ? (values[12] || 0) : (values[4] || 0);
    }

    function sync() {
      var width = container.clientWidth || (container.parentElement && container.parentElement.clientWidth) || 1;
      var index = Math.max(0, Math.min(slides.length - 1, Math.round(Math.abs(transformX()) / width)));
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === index;
        slide.classList.toggle('is-selected', active);
        slide.classList.toggle('is-in-view', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dotItems.forEach(function (dot, dotIndex) {
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
      var selectedMediaId = String(slides[index] && slides[index].getAttribute('data-media-id') || '');
      thumbnails.forEach(function (thumbnail, thumbnailIndex) {
        var active = selectedMediaId
          ? String(thumbnail.getAttribute('data-media-id') || '') === selectedMediaId
          : thumbnailIndex === index;
        thumbnail.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (current) current.textContent = String(index + 1);
      if (total) total.textContent = String(slides.length);
      if (previous) {
        previous.disabled = index === 0;
        previous.setAttribute('aria-label', 'Önceki görsel');
      }
      if (next) {
        next.disabled = index === slides.length - 1;
        next.setAttribute('aria-label', 'Sonraki görsel');
      }
    }

    sync();
    if (window.MutationObserver) {
      this.galleryObserver = new MutationObserver(function () {
        window.requestAnimationFrame(sync);
      });
      this.galleryObserver.observe(container, { attributes: true, attributeFilter: ['style'] });
    }
    window.setTimeout(sync, 500);
  };

  Option3.prototype.initGalleryLightbox = function () {
    var productSection = this.root.closest('.hdt-main-product');
    var mediaMain = productSection && query(productSection, '.hdt-product-media__main');
    if (!productSection || !mediaMain) return;

    if (this.galleryDelegateSection && this.galleryDelegateSection !== productSection) {
      this.galleryDelegateSection.removeEventListener('click', this.galleryCaptureClick, true);
      this.galleryDelegateSection.removeEventListener('pointerdown', this.galleryBasePointerDown, true);
      this.galleryDelegateSection.removeEventListener('pointerup', this.galleryBasePointerUp, true);
      this.galleryDelegateSection.removeEventListener('pointercancel', this.galleryBasePointerCancel, true);
    }

    this.productSection = productSection;
    this.galleryMain = mediaMain;
    this.ensureGalleryLightbox();
    if (this.galleryDelegateSection === productSection) return;

    var self = this;
    this.galleryCaptureClick = function (event) {
      var target = event.target;
      if (!target || !target.closest || !self.galleryMain || !self.galleryMain.contains(target)) return;
      if (target.closest('button, video, iframe, model-viewer, input, select, textarea')) return;
      var image = target.closest('img');
      var slide = image && image.closest('.hdt-slider__slide[data-media-type="image"]');
      if (!image || !slide || !self.galleryMain.contains(slide)) return;
      if (!slide.classList.contains('is-selected') && !slide.classList.contains('is-in-view')) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      if (Date.now() < (self.galleryBaseSuppressClickUntil || 0)) return;
      self.openGalleryLightbox(slide.getAttribute('data-media-id'), image);
    };

    this.galleryBasePointerDown = function (event) {
      if (event.isPrimary === false || !event.target || !event.target.closest) return;
      var image = event.target.closest('.hdt-product-media__main .hdt-slider__slide[data-media-type="image"] img');
      if (!image || !productSection.contains(image)) return;
      self.galleryBaseGesture = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY
      };
    };
    this.galleryBasePointerUp = function (event) {
      var gesture = self.galleryBaseGesture;
      if (!gesture || (gesture.id != null && event.pointerId !== gesture.id)) return;
      self.galleryBaseGesture = null;
      if (Math.abs(event.clientX - gesture.x) > 12 || Math.abs(event.clientY - gesture.y) > 12) {
        self.galleryBaseSuppressClickUntil = Date.now() + 500;
      }
    };
    this.galleryBasePointerCancel = function () { self.galleryBaseGesture = null; };

    productSection.addEventListener('click', this.galleryCaptureClick, true);
    productSection.addEventListener('pointerdown', this.galleryBasePointerDown, true);
    productSection.addEventListener('pointerup', this.galleryBasePointerUp, true);
    productSection.addEventListener('pointercancel', this.galleryBasePointerCancel, true);
    this.galleryDelegateSection = productSection;
  };

  Option3.prototype.ensureGalleryLightbox = function () {
    if (this.galleryLightbox && this.galleryLightbox.isConnected) return this.galleryLightbox;
    var stale = document.querySelector('[data-dv-fixed-gallery-lightbox]');
    if (stale) {
      var staleOwner = stale.dvFixedGalleryOwner;
      if (staleOwner && staleOwner !== this && typeof staleOwner.closeGalleryLightbox === 'function') {
        staleOwner.closeGalleryLightbox();
      }
      stale.querySelectorAll('video').forEach(function (video) { try { video.pause(); } catch (_) {} });
      stale.remove();
    }

    var overlay = document.createElement('div');
    overlay.className = 'dv-fixed-gallery-lightbox';
    overlay.hidden = true;
    overlay.dataset.dvFixedGalleryLightbox = GALLERY_LIGHTBOX_SENTINEL;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Ürün medyası tam ekran galerisi');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.dvFixedGalleryOwner = this;

    var topbar = document.createElement('div');
    topbar.className = 'dv-fixed-gallery-lightbox__topbar';
    var counter = document.createElement('span');
    counter.className = 'dv-fixed-gallery-lightbox__counter';
    counter.setAttribute('aria-live', 'polite');
    counter.setAttribute('aria-atomic', 'true');
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'dv-fixed-gallery-lightbox__close';
    close.textContent = 'Kapat';
    close.setAttribute('aria-label', 'Tam ekran galeriyi kapat');
    topbar.appendChild(counter);
    topbar.appendChild(close);

    var stage = document.createElement('div');
    stage.className = 'dv-fixed-gallery-lightbox__stage';
    var media = document.createElement('div');
    media.className = 'dv-fixed-gallery-lightbox__media';
    media.setAttribute('aria-live', 'off');
    var previous = this.createGalleryLightboxButton(
      'dv-fixed-gallery-lightbox__nav dv-fixed-gallery-lightbox__nav--prev',
      'Önceki medya',
      '.hdt-product-media__main .hdt-slider__button--prev'
    );
    var next = this.createGalleryLightboxButton(
      'dv-fixed-gallery-lightbox__nav dv-fixed-gallery-lightbox__nav--next',
      'Sonraki medya',
      '.hdt-product-media__main .hdt-slider__button--next'
    );
    stage.appendChild(media);
    stage.appendChild(previous);
    stage.appendChild(next);
    overlay.appendChild(topbar);
    overlay.appendChild(stage);
    document.body.appendChild(overlay);

    this.galleryLightbox = overlay;
    this.galleryLightboxCounter = counter;
    this.galleryLightboxClose = close;
    this.galleryLightboxStage = stage;
    this.galleryLightboxMedia = media;
    this.galleryLightboxPrevious = previous;
    this.galleryLightboxNext = next;

    var self = this;
    close.addEventListener('click', function () { self.closeGalleryLightbox(); });
    previous.addEventListener('click', function () { self.moveGalleryLightbox(-1); });
    next.addEventListener('click', function () { self.moveGalleryLightbox(1); });
    media.addEventListener('click', function (event) {
      if (!self.galleryLightboxOpen || Date.now() < (self.galleryLightboxSuppressClickUntil || 0)) return;
      if (event.target && event.target.closest && event.target.closest('video, iframe, button, a')) return;
      self.closeGalleryLightbox();
    });
    overlay.addEventListener('keydown', function (event) { self.handleGalleryLightboxKeydown(event); });

    stage.addEventListener('pointerdown', function (event) {
      if (event.isPrimary === false || event.button > 0) return;
      if (event.target && event.target.closest && event.target.closest('button, iframe, video')) return;
      self.galleryLightboxGesture = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY
      };
      if (stage.setPointerCapture && event.pointerId != null) {
        try { stage.setPointerCapture(event.pointerId); } catch (_) {}
      }
    }, true);
    stage.addEventListener('pointerup', function (event) {
      var gesture = self.galleryLightboxGesture;
      if (!gesture || (gesture.id != null && event.pointerId !== gesture.id)) return;
      self.galleryLightboxGesture = null;
      var deltaX = event.clientX - gesture.x;
      var deltaY = event.clientY - gesture.y;
      if (Math.abs(deltaX) < 44 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;
      event.preventDefault();
      self.galleryLightboxSuppressClickUntil = Date.now() + 500;
      self.moveGalleryLightbox(deltaX < 0 ? 1 : -1);
    }, true);
    stage.addEventListener('pointercancel', function () { self.galleryLightboxGesture = null; }, true);
    return overlay;
  };

  Option3.prototype.createGalleryLightboxButton = function (className, label, sourceSelector) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.setAttribute('aria-label', label);
    var source = this.productSection && query(this.productSection, sourceSelector);
    if (source && source.childNodes.length) {
      Array.prototype.forEach.call(source.childNodes, function (node) {
        button.appendChild(node.cloneNode(true));
      });
    } else {
      button.textContent = label;
    }
    return button;
  };

  Option3.prototype.galleryUrl = function (value) {
    var url = String(value || '').trim();
    if (!url || /^data:image\/(?:gif|png);base64/i.test(url)) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    return url;
  };

  Option3.prototype.gallerySrcsetUrl = function (value) {
    var self = this;
    var candidates = String(value || '').split(',').map(function (candidate) {
      var parts = candidate.trim().split(/\s+/);
      return { url: self.galleryUrl(parts[0]), width: parseInt(parts[1], 10) || 0 };
    }).filter(function (candidate) { return candidate.url; });
    candidates.sort(function (left, right) { return right.width - left.width; });
    return candidates.length ? candidates[0].url : '';
  };

  Option3.prototype.readGalleryMedia = function () {
    var self = this;
    if (!this.productSection) return [];
    var slides = Array.prototype.slice.call(
      this.productSection.querySelectorAll('.hdt-product-media__main .hdt-slider__slide')
    ).filter(function (slide) {
      return !slide.hidden && !slide.classList.contains('ultra-3d-gallery-slide');
    });

    return slides.map(function (slide, index) {
      var declaredType = String(slide.getAttribute('data-media-type') || '').toLowerCase();
      var video = slide.querySelector('video');
      var iframe = slide.querySelector('iframe');
      var image = slide.querySelector('img');
      var mediaId = String(slide.getAttribute('data-media-id') || index);
      if (declaredType === 'video' || video) {
        var sources = [];
        if (video) {
          var ownSource = self.galleryUrl(video.getAttribute('src'));
          if (ownSource) sources.push({ src: ownSource, type: video.getAttribute('type') || 'video/mp4' });
          video.querySelectorAll('source').forEach(function (source) {
            var src = self.galleryUrl(source.getAttribute('src'));
            if (src && !sources.some(function (candidate) { return candidate.src === src; })) {
              sources.push({ src: src, type: source.getAttribute('type') || 'video/mp4' });
            }
          });
        }
        return {
          id: mediaId,
          type: 'video',
          alt: (image && image.getAttribute('alt')) || 'Ürün videosu',
          poster: self.galleryUrl(image && image.getAttribute('src')) ||
            self.gallerySrcsetUrl(image && (image.getAttribute('srcset') || image.getAttribute('data-srcset'))) ||
            self.galleryUrl(image && image.currentSrc) ||
            self.galleryUrl(image && (image.getAttribute('d-src') || image.getAttribute('data-src'))) ||
            self.galleryUrl(video && (video.getAttribute('poster') || video.getAttribute('data-poster'))),
          sources: sources,
          slide: slide
        };
      }
      if (declaredType === 'external_video' || iframe) {
        return {
          id: mediaId,
          type: 'external_video',
          alt: (iframe && iframe.getAttribute('title')) || 'Ürün videosu',
          src: self.galleryUrl(iframe && (iframe.getAttribute('src') || iframe.getAttribute('data-src') || iframe.getAttribute('d-src'))),
          slide: slide
        };
      }
      if (!image) return null;
      var zoom = slide.querySelector('.zoom-data[data-high-res-src]');
      var src = self.galleryUrl(zoom && zoom.getAttribute('data-high-res-src')) ||
        self.galleryUrl(image.currentSrc) ||
        self.galleryUrl(image.getAttribute('src')) ||
        self.galleryUrl(image.getAttribute('d-src')) ||
        self.galleryUrl(image.getAttribute('data-src')) ||
        self.gallerySrcsetUrl(image.getAttribute('srcset') || image.getAttribute('data-srcset'));
      if (!src) return null;
      return {
        id: mediaId,
        type: 'image',
        alt: image.getAttribute('alt') || 'Ürün görseli',
        src: src,
        slide: slide
      };
    }).filter(Boolean);
  };

  Option3.prototype.openGalleryLightbox = function (mediaId, origin) {
    var overlay = this.ensureGalleryLightbox();
    var media = this.readGalleryMedia();
    if (!overlay || !media.length) return;
    var index = media.findIndex(function (item) { return String(item.id) === String(mediaId); });
    if (index < 0 && origin && origin.matches && origin.matches('[data-dv-fixed-story-detail-trigger]')) return;
    if (index < 0) {
      index = media.findIndex(function (item) { return item.slide.classList.contains('is-selected'); });
    }
    this.galleryLightboxItems = media;
    this.galleryLightboxIndex = index < 0 ? 0 : index;
    this.galleryLightboxOrigin = origin || document.activeElement;
    this.lockGalleryPage();
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    this.galleryLightboxOpen = true;
    this.renderGalleryLightbox();
    window.requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    if (this.galleryLightboxClose && typeof this.galleryLightboxClose.focus === 'function') {
      this.galleryLightboxClose.focus({ preventScroll: true });
    }
  };

  Option3.prototype.renderGalleryLightbox = function () {
    var items = this.galleryLightboxItems || [];
    if (!items.length || !this.galleryLightboxMedia) return;
    var index = Math.max(0, Math.min(items.length - 1, this.galleryLightboxIndex || 0));
    this.galleryLightboxIndex = index;
    var item = items[index];
    this.pauseGalleryLightboxVideos();
    while (this.galleryLightboxMedia.firstChild) this.galleryLightboxMedia.removeChild(this.galleryLightboxMedia.firstChild);

    var node;
    if (item.type === 'video') {
      node = document.createElement('video');
      node.className = 'dv-fixed-gallery-lightbox__video';
      node.controls = true;
      node.playsInline = true;
      node.preload = 'metadata';
      node.setAttribute('playsinline', '');
      node.setAttribute('aria-label', item.alt || 'Ürün videosu');
      if (item.poster) node.poster = item.poster;
      item.sources.forEach(function (sourceData) {
        var source = document.createElement('source');
        source.src = sourceData.src;
        source.type = sourceData.type;
        node.appendChild(source);
      });
    } else if (item.type === 'external_video' && item.src) {
      node = document.createElement('div');
      node.className = 'dv-fixed-gallery-lightbox__external-wrap';
      var frame = document.createElement('iframe');
      frame.className = 'dv-fixed-gallery-lightbox__external-video';
      frame.src = item.src;
      frame.title = item.alt || 'Ürün videosu';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.setAttribute('allowfullscreen', '');
      var leftGuard = document.createElement('div');
      leftGuard.className = 'dv-fixed-gallery-lightbox__swipe-guard dv-fixed-gallery-lightbox__swipe-guard--left';
      leftGuard.setAttribute('aria-hidden', 'true');
      var rightGuard = document.createElement('div');
      rightGuard.className = 'dv-fixed-gallery-lightbox__swipe-guard dv-fixed-gallery-lightbox__swipe-guard--right';
      rightGuard.setAttribute('aria-hidden', 'true');
      node.appendChild(frame);
      node.appendChild(leftGuard);
      node.appendChild(rightGuard);
    } else {
      node = document.createElement('img');
      node.className = 'dv-fixed-gallery-lightbox__image';
      node.src = item.src || item.poster || '';
      node.alt = item.alt || 'Ürün görseli';
      node.draggable = false;
      node.decoding = 'async';
    }
    node.dataset.dvFixedGalleryMedia = item.type;
    this.galleryLightboxMedia.appendChild(node);
    this.galleryLightbox.dataset.mediaId = item.id;
    this.galleryLightbox.dataset.mediaType = item.type;
    this.galleryLightboxCounter.textContent = String(index + 1) + ' / ' + String(items.length);
    this.galleryLightboxPrevious.disabled = index === 0;
    this.galleryLightboxNext.disabled = index === items.length - 1;
    this.galleryLightboxPrevious.setAttribute('aria-disabled', index === 0 ? 'true' : 'false');
    this.galleryLightboxNext.setAttribute('aria-disabled', index === items.length - 1 ? 'true' : 'false');
  };

  Option3.prototype.moveGalleryLightbox = function (delta) {
    if (!this.galleryLightboxOpen) return;
    var next = Math.max(0, Math.min(this.galleryLightboxItems.length - 1, this.galleryLightboxIndex + delta));
    if (next === this.galleryLightboxIndex) return;
    this.galleryLightboxIndex = next;
    this.renderGalleryLightbox();
  };

  Option3.prototype.pauseGalleryLightboxVideos = function () {
    if (!this.galleryLightbox) return;
    this.galleryLightbox.querySelectorAll('video').forEach(function (video) {
      try { video.pause(); } catch (_) {}
    });
    this.galleryLightbox.querySelectorAll('iframe').forEach(function (frame) {
      try { frame.src = 'about:blank'; } catch (_) {}
    });
  };

  Option3.prototype.handleGalleryLightboxKeydown = function (event) {
    if (!this.galleryLightboxOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeGalleryLightbox();
      return;
    }
    var targetIsMediaControl = event.target && event.target.matches && event.target.matches('video, input, select, textarea');
    if (!targetIsMediaControl && event.key === 'ArrowLeft') {
      event.preventDefault();
      this.moveGalleryLightbox(-1);
      return;
    }
    if (!targetIsMediaControl && event.key === 'ArrowRight') {
      event.preventDefault();
      this.moveGalleryLightbox(1);
      return;
    }
    if (event.key !== 'Tab') return;
    var controls = [this.galleryLightboxClose];
    var mediaControl = this.galleryLightbox.querySelector('video, iframe');
    if (mediaControl) controls.push(mediaControl);
    [this.galleryLightboxPrevious, this.galleryLightboxNext].forEach(function (control) {
      if (control && !control.disabled && !control.hidden) controls.push(control);
    });
    if (!controls.length) return;
    var first = controls[0];
    var last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  Option3.prototype.lockGalleryPage = function () {
    if (this.galleryScrollState) return;
    var body = document.body;
    var root = document.documentElement;
    this.galleryScrollState = {
      y: window.scrollY || window.pageYOffset || 0,
      bodyPosition: body.style.position,
      bodyTop: body.style.top,
      bodyLeft: body.style.left,
      bodyRight: body.style.right,
      bodyWidth: body.style.width,
      bodyOverflow: body.style.overflow,
      rootOverflow: root.style.overflow
    };
    root.classList.add('dv-fixed-gallery-open');
    body.classList.add('dv-fixed-gallery-open');
    root.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = '-' + String(this.galleryScrollState.y) + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
  };

  Option3.prototype.unlockGalleryPage = function () {
    var state = this.galleryScrollState;
    if (!state) return;
    var body = document.body;
    var root = document.documentElement;
    root.classList.remove('dv-fixed-gallery-open');
    body.classList.remove('dv-fixed-gallery-open');
    root.style.overflow = state.rootOverflow;
    body.style.position = state.bodyPosition;
    body.style.top = state.bodyTop;
    body.style.left = state.bodyLeft;
    body.style.right = state.bodyRight;
    body.style.width = state.bodyWidth;
    body.style.overflow = state.bodyOverflow;
    this.galleryScrollState = null;
    window.scrollTo(0, state.y);
  };

  Option3.prototype.syncGalleryLightboxToPage = function () {
    var item = this.galleryLightboxItems && this.galleryLightboxItems[this.galleryLightboxIndex];
    if (!item || !this.productSection) return this.galleryLightboxOrigin;
    var mediaId = String(item.id);
    var thumbnails = this.productSection.querySelectorAll('.hdt-product-media__thumb [data-media-id]');
    var targetThumbnail = null;
    Array.prototype.some.call(thumbnails, function (thumbnail) {
      if (String(thumbnail.getAttribute('data-media-id')) !== mediaId) return false;
      targetThumbnail = thumbnail;
      return true;
    });
    if (targetThumbnail && typeof targetThumbnail.click === 'function') targetThumbnail.click();
    var targetSlide = item.slide && item.slide.isConnected
      ? item.slide
      : this.productSection.querySelector('.hdt-product-media__main [data-media-id="' + CSS.escape(mediaId) + '"]');
    if (this.galleryLightboxOrigin &&
        this.galleryLightboxOrigin.matches &&
        this.galleryLightboxOrigin.matches('[data-dv-fixed-story-detail-trigger]')) {
      return this.galleryLightboxOrigin;
    }
    return (targetSlide && targetSlide.querySelector('img, video')) || targetSlide || this.galleryLightboxOrigin;
  };

  Option3.prototype.closeGalleryLightbox = function () {
    if (!this.galleryLightboxOpen || !this.galleryLightbox) return;
    this.galleryLightboxOpen = false;
    this.pauseGalleryLightboxVideos();
    this.galleryLightbox.classList.remove('is-open');
    this.galleryLightbox.hidden = true;
    this.galleryLightbox.setAttribute('aria-hidden', 'true');
    this.unlockGalleryPage();
    var focusTarget = this.syncGalleryLightboxToPage();
    while (this.galleryLightboxMedia && this.galleryLightboxMedia.firstChild) {
      this.galleryLightboxMedia.removeChild(this.galleryLightboxMedia.firstChild);
    }
    if (focusTarget && focusTarget.isConnected && typeof focusTarget.focus === 'function') {
      var hadTabindex = focusTarget.hasAttribute && focusTarget.hasAttribute('tabindex');
      if (!hadTabindex && focusTarget.setAttribute) focusTarget.setAttribute('tabindex', '-1');
      try { focusTarget.focus({ preventScroll: true }); } catch (_) { try { focusTarget.focus(); } catch (_) {} }
      if (!hadTabindex && focusTarget.removeAttribute && focusTarget.addEventListener) {
        focusTarget.addEventListener('blur', function cleanupGalleryFocusTarget() {
          focusTarget.removeAttribute('tabindex');
        }, { once: true });
      }
    }
    this.galleryLightboxItems = [];
    this.galleryLightboxOrigin = null;
  };

  Option3.prototype.decorateVariants = function () {
    var self = this;
    var optionLabel = this.root.querySelector('.dv-fixed-option3__variants .hdt-product-form__label');
    if (optionLabel) {
      var optionLabelTextRoot = optionLabel.querySelector('span') || optionLabel;
      Array.prototype.some.call(optionLabelTextRoot.childNodes, function (node) {
        if (node.nodeType !== 3 || !node.nodeValue.trim()) return false;
        node.nodeValue = 'Hazır ebatlar ';
        return true;
      });
    }
    this.root.querySelectorAll('.hdt-product-form__values input[type="radio"]').forEach(function (input) {
      var variant = self.config.variants.find(function (candidate) {
        return String(candidate.title || '') === String(input.value || '');
      });
      if (!variant) return;
      var label = self.root.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      if (!label) return;
      Array.prototype.forEach.call(label.childNodes, function (node) {
        if (node.nodeType === 3 && node.nodeValue.trim()) {
          node.nodeValue = node.nodeValue.replace(/\s*[xX]\s*/g, '×');
        }
      });
      var old = label.querySelector('.dv-fixed-option3__variant-status');
      if (old) old.remove();
      var status = document.createElement('small');
      status.className = 'dv-fixed-option3__variant-status';
      status.textContent = variant.available ? 'Stokta' : 'Tükendi';
      label.appendChild(status);
      if (!variant.available) {
        // Tükenen ebat seçilebilir kalır; aksi halde müşteri o ebada stok alarmı
        // kuramaz. Satın alma düğmesi render() içinde yine fail-closed kapanır.
        input.disabled = false;
        input.removeAttribute('aria-disabled');
        input.classList.remove('is-disabled');
        input.classList.add('is-sold-out');
        label.classList.add('is-sold-out');
      } else {
        // Rulo/parça stoğu bir tükenmiş varyantı tekrar satın alınabilir yaptığında
        // tema tarafından basılan eski durum sınıfları ve ekran okuyucu metni kalmasın.
        input.disabled = false;
        input.removeAttribute('aria-disabled');
        input.classList.remove('is-disabled', 'is-sold-out');
        label.classList.remove('is-sold-out');
        label.querySelectorAll('.sr-only').forEach(function (message) {
          if (/tükendi/i.test(String(message.textContent || ''))) message.remove();
        });
      }
    });
  };

  Option3.prototype.bind = function () {
    var self = this;
    if (this.nodes.sizeToggle) {
      this.nodes.sizeToggle.addEventListener('click', function () {
        var open = self.root.dataset.sizePickerOpen !== 'true';
        self.root.dataset.sizePickerOpen = open ? 'true' : 'false';
        self.nodes.sizeToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (self.nodes.stickySummary) self.nodes.stickySummary.setAttribute('aria-expanded', open ? 'true' : 'false');
        self.nodes.sizeToggle.textContent = open ? 'Ölçüleri kapat' : 'Ölçüyü değiştir';
        if (self.nodes.sizeSummary) self.nodes.sizeSummary.dataset.open = open ? 'true' : 'false';
        if (open && self.nodes.variants) {
          var selectedSize = self.nodes.variants.querySelector('input[type="radio"]:checked');
          if (selectedSize && typeof selectedSize.focus === 'function') {
            window.setTimeout(function () {
              try { selectedSize.focus({ preventScroll: true }); } catch (_) { selectedSize.focus(); }
            }, 0);
          }
          scrollExpandedRegion(self.nodes.variants);
        }
      });
    }
    if (this.nodes.stickySummary && this.nodes.sizeToggle) {
      this.nodes.stickySummary.addEventListener('click', function () {
        self.nodes.sizeToggle.click();
      });
    }
    if (this.nodes.variants && window.MutationObserver) {
      this.rollAvailabilityObserver = new MutationObserver(function (records) {
        var recovered = records.some(function (record) {
          return record.type === 'attributes' &&
            record.attributeName === 'data-dv-parca-ok' &&
            record.target && record.target.matches &&
            record.target.matches('label[data-dv-parca-ok]');
        });
        if (recovered) self.decorateVariants();
      });
      this.rollAvailabilityObserver.observe(this.nodes.variants, {
        subtree: true,
        attributes: true,
        attributeFilter: ['data-dv-parca-ok']
      });
      window.setTimeout(function () {
        if (self.nodes.variants.querySelector('label[data-dv-parca-ok]')) self.decorateVariants();
      }, 0);
    }
    if (this.nodes.watchVideos) this.nodes.watchVideos.addEventListener('click', function () { self.openProductVideo(); });
    if (this.nodes.roomView) this.nodes.roomView.addEventListener('click', function () { self.openRoomView(); });
    if (this.nodes.whatsapp) this.nodes.whatsapp.addEventListener('click', function () { self.openWhatsapp(); });
    this.root.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.matches('input[type="radio"]')) {
        var byTitle = self.config.variants.find(function (candidate) {
          return String(candidate.title || '') === String(target.value || '');
        });
        if (byTitle) self.selectVariant(byTitle, 'picker');
        self.scheduleDomSync();
      }
      if (target && target.matches('input[name="quantity"]')) self.render();
    });
    this.root.addEventListener('input', function (event) {
      if (event.target && event.target.matches('input[name="quantity"]')) self.render();
    });
    this.root.addEventListener('click', function (event) {
      var retry = event.target && event.target.closest
        ? event.target.closest('[data-dv-fixed-cart-retry]')
        : null;
      if (retry) {
        event.preventDefault();
        if (self.variant && self.eligibilityState !== 'checking') {
          self.loadEligibility(self.variant, { force: true });
        }
        return;
      }
      var target = event.target && event.target.closest
        ? event.target.closest('button[name="plus"], button[name="minus"]')
        : null;
      if (!target) return;
      [0, 60, 180].forEach(function (delay) {
        window.setTimeout(function () { self.render(); }, delay);
      });
    });

    if (this.form) {
      this.form.addEventListener('change', function () { self.scheduleDomSync(); });
      this.form.addEventListener('submit', function (event) {
        if (self.submitLocked) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        self.lockSubmission();
        self.scheduleCartPresentation();
      }, true);
      var idInput = this.form.querySelector('[name="id"]');
      if (idInput && window.MutationObserver) {
        this.variantObserver = new MutationObserver(function () { self.scheduleDomSync(); });
        this.variantObserver.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
    }

    if (this.nodes.buyButton) {
      this.nodes.buyButton.addEventListener('click', function (event) {
        var now = Date.now();
        if (now - self.lastButtonClickAt < 900) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        self.lastButtonClickAt = now;
      }, true);
    }

    if (this.nodes.stickyButton) {
      this.nodes.stickyButton.addEventListener('click', function () {
        if (!self.nodes.buyButton || self.nodes.stickyButton.disabled || self.submitLocked) return;
        if (self.form && typeof self.form.requestSubmit === 'function') {
          self.form.requestSubmit(self.nodes.buyButton);
        } else {
          self.nodes.buyButton.click();
        }
      });
    }

    function openAlertPanel() {
      if (!self.nodes.alertPanel || !self.nodes.alertToggle) return;
      setHidden(self.nodes.alertPanel, false);
      self.nodes.alertToggle.setAttribute('aria-expanded', 'true');
      scrollExpandedRegion(self.nodes.alertEmail || self.nodes.alert, 'center');
      if (self.nodes.alertEmail && typeof self.nodes.alertEmail.focus === 'function') {
        window.setTimeout(function () {
          try { self.nodes.alertEmail.focus({ preventScroll: true }); } catch (_) { self.nodes.alertEmail.focus(); }
        }, 0);
      }
    }

    if (this.nodes.alertToggle) {
      this.nodes.alertToggle.addEventListener('click', function () {
        if (!self.nodes.alertPanel) return;
        var opening = self.nodes.alertPanel.hidden;
        setHidden(self.nodes.alertPanel, !opening);
        self.nodes.alertToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (opening) scrollExpandedRegion(self.nodes.alertEmail || self.nodes.alert, 'center');
        if (opening && self.nodes.alertEmail && typeof self.nodes.alertEmail.focus === 'function') {
          window.setTimeout(function () {
            try { self.nodes.alertEmail.focus({ preventScroll: true }); } catch (_) { self.nodes.alertEmail.focus(); }
          }, 0);
        }
      });
    }

    if (this.nodes.priceProofToggle) {
      this.nodes.priceProofToggle.addEventListener('click', function () {
        if (!self.nodes.priceProofPanel || self.nodes.priceProof.hidden) return;
        var opening = self.nodes.priceProofPanel.hidden;
        setHidden(self.nodes.priceProofPanel, !opening);
        self.nodes.priceProofToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (opening) scrollExpandedRegion(self.nodes.priceProofToggle || self.nodes.priceProof, 'center');
      });
    }

    if (this.nodes.stickyAlert) {
      this.nodes.stickyAlert.addEventListener('click', function () {
        openAlertPanel();
      });
    }

    if (this.nodes.alertSubmit) {
      this.nodes.alertSubmit.addEventListener('click', function () { self.submitAlert(); });
    }

    if (this.nodes.alertEmail) {
      this.nodes.alertEmail.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        self.submitAlert();
      });
    }

    ['variant:change', 'variant:changed', 'product:variant-change', 'hdt:variant:changed'].forEach(function (name) {
      document.addEventListener(name, function (event) {
        var detail = event && event.detail;
        var candidate = detail && (detail.variant || detail);
        var id = candidate && (candidate.id || candidate.variantId);
        if (id && self.variants.has(String(id))) self.selectVariant(self.variants.get(String(id)), name);
      });
    });

    ['cart:updated', 'cart:add:success', 'cart:refresh'].forEach(function (name) {
      document.addEventListener(name, function () {
        self.unlockSubmission();
        self.scheduleCartPresentation();
      });
    });
  };

  Option3.prototype.scheduleCartPresentation = function () {
    var self = this;
    [180, 520, 1100, 1900].forEach(function (delay) {
      window.setTimeout(function () { self.syncCartPresentation(); }, delay);
    });
  };

  Option3.prototype.syncCartPresentation = function () {
    if (!this.variant) return;
    var variant = this.variant;
    var algorithm = validAlgorithm(variant, Date.now());
    var productPath = '/products/' + String(this.root.dataset.productHandle || '');

    document.querySelectorAll('hdt-line-item').forEach(function (line) {
      var titleLink = line.querySelector('.hdt-mini-cart__title[href]');
      if (!titleLink) return;
      var pathname = '';
      try {
        pathname = new URL(titleLink.getAttribute('href'), window.location.origin).pathname;
      } catch (_) {
        return;
      }
      if (pathname !== productPath) return;
      var lineVariantId = String(line.getAttribute('data-variant-id') || '');
      if (lineVariantId && lineVariantId !== String(variant.id)) return;
      var badge = line.querySelector('.dolce-cart-badge-final');
      var value = badge && badge.querySelector('.badge-percent');
      var label = badge && badge.querySelector('.badge-label');
      if (!badge || !value || !label) return;
      var serverDiscountSource = String(
        badge.getAttribute('data-discount-source') ||
        line.getAttribute('data-discount-source') ||
        ''
      );
      if (!algorithm) {
        if (!serverDiscountSource || serverDiscountSource === 'product-price' || serverDiscountSource === 'none') {
          badge.hidden = true;
          badge.removeAttribute('data-discount-source');
          value.textContent = '';
          label.textContent = '';
        }
        return;
      }
      badge.hidden = false;
      value.textContent = '%' + percentage(Math.round(Number(algorithm.percent)));
      label.textContent = 'FIRSAT İNDİRİMİ';
      badge.dataset.discountSource = 'deal-wave';
      line.dataset.discountSource = 'deal-wave';
    });
  };

  Option3.prototype.scheduleDomSync = function () {
    var self = this;
    [0, 60, 220].forEach(function (delay) {
      window.setTimeout(function () { self.syncFromDom(); }, delay);
    });
  };

  Option3.prototype.syncFromDom = function () {
    if (!this.form) return;
    var input = this.form.querySelector('[name="id"]');
    var id = input && String(input.value || '');
    if (id && this.variants.has(id) && (!this.variant || this.variant.id !== id)) {
      this.selectVariant(this.variants.get(id), 'form');
    }
  };

  Option3.prototype.syncVariantIdentity = function (variant, source) {
    if (!variant || !variant.id) return;
    var selectedUrl = selectedVariantUrl(variant.id);
    if (selectedUrl && window.history && typeof window.history.replaceState === 'function') {
      var currentVariant = new URL(window.location.href).searchParams.get('variant');
      if (currentVariant !== variant.id) {
        window.history.replaceState(
          window.history.state,
          '',
          selectedUrl.pathname + selectedUrl.search + selectedUrl.hash
        );
      }
    }

    var idInput = this.form && this.form.querySelector('[name="id"]');
    if (idInput && String(idInput.value || '') !== variant.id) idInput.value = variant.id;

    if (!this.nodes.productSchema) return;
    var algorithm = validAlgorithm(variant, Date.now());
    var canonicalUrl = String(this.config.canonicalUrl || '').trim();
    var productName = String(this.config.productTitle || '').trim();
    var currency = String(this.config.currency || '').trim().toUpperCase();
    if (!canonicalUrl || !productName || !currency || !selectedUrl) {
      this.nodes.productSchema.textContent = '';
      this.nodes.productSchema.dataset.state = 'invalid-config';
      return;
    }
    var schemaUrl;
    try {
      schemaUrl = new URL(canonicalUrl);
    } catch (_) {
      this.nodes.productSchema.textContent = '';
      this.nodes.productSchema.dataset.state = 'invalid-config';
      return;
    }
    schemaUrl.searchParams.set('variant', variant.id);
    var offer = {
      '@type': 'Offer',
      url: schemaUrl.toString(),
      priceCurrency: currency,
      price: (variant.priceCents / 100).toFixed(2),
      availability: variant.available === true
        ? 'https://schema.org/InStock'
        : 'https://schema.org/OutOfStock',
      itemCondition: 'https://schema.org/NewCondition'
    };
    if (algorithm) offer.priceValidUntil = new Date(Date.parse(algorithm.endAt)).toISOString().slice(0, 10);
    var schema = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      '@id': canonicalUrl + '#variant-' + variant.id,
      name: productName,
      url: schemaUrl.toString(),
      sku: String(variant.sku || ''),
      mpn: String(variant.sku || ''),
      brand: { '@type': 'Brand', name: 'Dolce Vita Halı' },
      offers: offer
    };
    var imageUrl = String(variant.imageUrl || this.config.productImage || '').trim();
    if (imageUrl) schema.image = [imageUrl];
    this.nodes.productSchema.textContent = JSON.stringify(schema);
    this.nodes.productSchema.dataset.state = 'selected-variant';
    this.nodes.productSchema.dataset.variantId = variant.id;
    this.root.dataset.variantUrlSource = source || 'unknown';
  };

  Option3.prototype.syncAlertPresentation = function (variant) {
    if (!variant) return;
    var stockMode = variant.available !== true;
    var title = stockMode ? 'Stok gelince haber ver' : 'Fiyat düşünce haber ver';
    var shortTitle = stockMode ? 'Stok gelince haber ver' : 'Fiyat alarmı';
    var hint = 'Seçili ' + String(variant.title || 'ebat') + ' ebadı için e-posta bildirimi gönderilir.';
    this.root.dataset.alertMode = stockMode ? 'stock' : 'price';
    if (this.nodes.alert) {
      this.nodes.alert.dataset.mode = stockMode ? 'stock' : 'price';
      this.nodes.alert.dataset.variantId = variant.id;
      this.nodes.alert.dataset.priceCents = String(variant.priceCents);
    }
    if (this.nodes.alertToggle) this.nodes.alertToggle.textContent = title;
    if (this.nodes.stickyAlert) this.nodes.stickyAlert.textContent = shortTitle;
    if (this.nodes.alertTitle) this.nodes.alertTitle.textContent = title;
    if (this.nodes.alertHint) this.nodes.alertHint.textContent = hint;
    if (this.nodes.alertSubmit) {
      this.nodes.alertSubmit.disabled = false;
      this.nodes.alertSubmit.textContent = stockMode ? 'Stok alarmını oluştur' : 'Fiyat alarmını oluştur';
    }
    if (this.nodes.alertStatus) {
      this.nodes.alertStatus.textContent = '';
      this.nodes.alertStatus.removeAttribute('data-state');
    }
  };

  Option3.prototype.alertErrorMessage = function (code) {
    var messages = {
      gecersiz_eposta: 'Geçerli bir e-posta adresi girin.',
      onay_gerekli: 'Bildirim onayını işaretleyin.',
      gecersiz_urun: 'Ürün doğrulanamadı. Sayfayı yenileyip tekrar deneyin.',
      gecersiz_varyant: 'Seçili ebat doğrulanamadı. Ebadı yeniden seçin.',
      gecersiz_fiyat: 'Güncel fiyat doğrulanamadı. Sayfayı yenileyin.',
      urun_eslesmedi: 'Ürün bilgisi güncellendi. Sayfayı yenileyin.',
      varyant_eslesmedi: 'Seçili ebat güncellendi. Sayfayı yenileyin.',
      fiyat_degisti: 'Fiyat değişti. Sayfayı yenileyip güncel fiyatla tekrar deneyin.',
      varyant_stokta: 'Bu ebat yeniden stokta. Satın alma alanından sepete ekleyebilirsiniz.',
      varyant_stokta_degil: 'Bu ebat artık stokta değil. Stok alarmını kullanın.',
      shopify_dogrulanamadi: 'Canlı ürün doğrulaması şu an tamamlanamadı. Kayıt yapılmadı; lütfen tekrar deneyin.',
      cok_fazla_istek: 'Çok fazla deneme yapıldı. Lütfen biraz sonra tekrar deneyin.',
      istek_zaman_asimi: 'Doğrulama zaman aşımına uğradı. Hiçbir alarm oluşturulmadı; lütfen tekrar deneyin.'
    };
    return messages[code] || 'Kayıt tamamlanamadı. Hiçbir alarm oluşturulmadı; lütfen tekrar deneyin.';
  };

  Option3.prototype.submitAlert = function () {
    var variant = this.variant;
    var email = this.nodes.alertEmail;
    var consent = this.nodes.alertConsent;
    var submit = this.nodes.alertSubmit;
    var status = this.nodes.alertStatus;
    if (!variant || !email || !consent || !submit || !status) return;
    if (String(this.root.dataset.variantId || '') !== variant.id) {
      status.dataset.state = 'error';
      status.textContent = 'Seçili ebat doğrulanamadı. Ebadı yeniden seçin.';
      return;
    }
    var emailValue = String(email.value || '').trim();
    if (typeof email.setCustomValidity === 'function') {
      email.setCustomValidity(emailValue ? '' : 'E-posta adresi zorunludur.');
    }
    if (!emailValue || (typeof email.checkValidity === 'function' && !email.checkValidity())) {
      if (typeof email.reportValidity === 'function') email.reportValidity();
      return;
    }
    if (!consent.checked) {
      status.dataset.state = 'error';
      status.textContent = 'Bildirim onayını işaretleyin.';
      if (typeof consent.focus === 'function') consent.focus();
      return;
    }
    var stockMode = variant.available !== true;
    var endpoint = String(stockMode
      ? this.root.dataset.stockAlarmUrl || ''
      : this.root.dataset.priceAlarmUrl || '').trim();
    if (!endpoint || typeof fetch !== 'function') {
      status.dataset.state = 'error';
      status.textContent = 'Canlı ürün doğrulaması kullanılamıyor. Kayıt yapılmadı.';
      return;
    }
    if (this.alertRequest && this.alertRequest.abort) this.alertRequest.abort();
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    this.alertRequest = controller;
    var sequence = (this.alertSequence || 0) + 1;
    this.alertSequence = sequence;
    var capturedId = variant.id;
    submit.disabled = true;
    submit.textContent = 'Doğrulanıyor…';
    status.dataset.state = 'pending';
    status.textContent = 'Seçili ebat ve güncel fiyat Shopify üzerinden doğrulanıyor.';
    var payload = {
      eposta: emailValue,
      pid: String(this.root.dataset.productId || ''),
      vid: capturedId,
      h: String(this.root.dataset.productHandle || ''),
      pc: variant.priceCents,
      olcu: String(variant.title || ''),
      c: '1'
    };
    var self = this;
    var timeoutTimer = null;
    var timeoutPromise = new Promise(function (_, reject) {
      timeoutTimer = window.setTimeout(function () {
        if (controller) controller.abort();
        var timeoutError = new Error('istek_zaman_asimi');
        timeoutError.code = 'istek_zaman_asimi';
        reject(timeoutError);
      }, ALERT_REQUEST_TIMEOUT_MS);
    });
    var requestPromise = fetch(endpoint, {
      method: 'POST',
      credentials: 'omit',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        if (!response.ok || body.ok !== true || body.verified !== true) {
          var error = new Error(String(body.hata || 'sunucu'));
          error.code = String(body.hata || 'sunucu');
          throw error;
        }
        return body;
      });
    });
    Promise.race([requestPromise, timeoutPromise]).then(function () {
      if (sequence !== self.alertSequence || !self.variant || self.variant.id !== capturedId) return;
      status.dataset.state = 'success';
      status.textContent = stockMode
        ? 'Stok alarmı seçili ebat için doğrulanarak oluşturuldu.'
        : 'Fiyat alarmı seçili ebat ve güncel fiyat için doğrulanarak oluşturuldu.';
    }).catch(function (error) {
      if (sequence !== self.alertSequence) return;
      status.dataset.state = 'error';
      status.textContent = self.alertErrorMessage(
        error && error.name === 'AbortError' ? 'istek_zaman_asimi' : error && error.code
      );
    }).finally(function () {
      window.clearTimeout(timeoutTimer);
      if (self.alertRequest === controller) self.alertRequest = null;
      if (sequence !== self.alertSequence || !self.variant || self.variant.id !== capturedId) return;
      submit.disabled = false;
      submit.textContent = stockMode ? 'Stok alarmını oluştur' : 'Fiyat alarmını oluştur';
    });
  };

  Option3.prototype.selectVariant = function (variant, source) {
    if (!variant) return;
    var changed = !this.variant || this.variant.id !== variant.id;
    if (changed && this.alertRequest && this.alertRequest.abort) this.alertRequest.abort();
    if (changed) {
      this.alertRequest = null;
      this.alertSequence = (this.alertSequence || 0) + 1;
    }
    this.variant = variant;
    this.cartDiscount = null;
    this.eligibilityState = this.eligibilityCache.has(variant.id) ? 'idle' : 'checking';
    this.root.dataset.variantId = variant.id;
    this.root.dataset.variantSource = source || 'unknown';
    this.syncVariantIdentity(variant, source);
    this.syncAlertPresentation(variant);
    if (this.primeSizeAlternative) this.primeSizeAlternative.update();
    this.render();
    if (changed || !this.eligibilityCache.has(variant.id)) this.loadEligibility(variant);
    else this.applyEligibility(this.eligibilityCache.get(variant.id));
  };

  Option3.prototype.quantity = function () {
    return clampQuantity(this.nodes.quantity ? this.nodes.quantity.value : 1);
  };

  // DV-QUALIFIED-COUPON-DISPLAY-20260906: presentation only. The existing
  // layout owns earned Google eligibility and code application. Never change
  // variant prices, cart data or discount policy from this display helper.
  // Current Admin proof: GN20K7P3, 10% (28 Eyl 2026: 20%->10%), all items, no minimum, once per customer;
  // Product/shipping combinations are allowed; another order discount is not.
  // DV_GOOGLE_PAID_POLICY_20260908: dates come from the live-policy snapshot in the layout.
  function googlePaidOfferWindow(w) {
    var p = w && w.__dvGooglePaidOfferPolicy;
    if (!p || p.schema !== 'dv.google-paid-offer.v1' || p.code !== 'GN20K7P3' ||
        p.percentage !== 10 || p.currency !== 'TRY' || p.oncePerCustomer !== true ||
        p.combinesWithProductDiscounts !== true || p.combinesWithOrderDiscounts !== false ||
        p.combinesWithShippingDiscounts !== true) return {start:NaN,end:NaN};
    var from = typeof p.startsAt === 'string' ? Date.parse(p.startsAt) : NaN;
    var through = typeof p.endsAt === 'string' ? Date.parse(p.endsAt) : NaN;
    return Number.isFinite(from) && Number.isFinite(through) && through > from ?
      {start:from,end:through} : {start:NaN,end:NaN};
  }
  var googlePaidOfferDates = googlePaidOfferWindow(typeof window === 'object' ? window : null);
  var GOOGLE_COUPON_START_MS = googlePaidOfferDates.start;
  var GOOGLE_COUPON_END_MS = googlePaidOfferDates.end;

  function ensureCouponCtaStyle() {
    if (document.getElementById('dv-fixed-coupon-cta-style')) return;
    var style = document.createElement('style');
    style.id = 'dv-fixed-coupon-cta-style';
    style.textContent = '.dv-fixed-option3 button[name="add"][data-dv-coupon-display="true"] > hdt-qty-price{display:none !important}';
    document.head.appendChild(style);
  }

  function qualifiedCouponDisplay(variant, quantity, currency, cart, now) {
    if (window.__dvGN20 !== true || currency !== 'TRY' || cart != null ||
        !Number.isFinite(now) || !Number.isFinite(GOOGLE_COUPON_START_MS) || !Number.isFinite(GOOGLE_COUPON_END_MS) ||
        now < GOOGLE_COUPON_START_MS || now >= GOOGLE_COUPON_END_MS ||
        !variant || variant.available !== true ||
        !Number.isSafeInteger(variant.priceCents) || variant.priceCents <= 0 ||
        !Number.isSafeInteger(quantity) || quantity <= 0 ||
        !Number.isSafeInteger(variant.priceCents * quantity)) return null;
    return {
      unitCents: calculateDiscountedCents(variant.priceCents, 10),
      totalCents: calculateDiscountedCents(variant.priceCents * quantity, 10),
      label: 'Kuponla sepette',
      condition: 'GN20K7P3 ile sepette %10 indirim. Müşteri başına bir kez; başka sepet indirimleriyle birleşmez.'
    };
  }

  Option3.prototype.bindCouponDisplayRefresh = function () {
    var self = this;
    function refresh() { if (self.variant) self.render(); }
    var now = Date.now();
    if (now < GOOGLE_COUPON_END_MS) {
      this.couponDisplayTimer = window.setTimeout(refresh,
        Math.min(2147483647, Math.max(1, GOOGLE_COUPON_END_MS - now + 1)));
    }
    window.addEventListener('pageshow', refresh);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refresh();
    });
  };

  Option3.prototype.render = function () {
    if (!this.variant) return;
    var variant = this.variant;
    var quantity = this.quantity();
    var currentTotal = variant.priceCents * quantity;
    var algorithm = validAlgorithm(variant, Date.now());
    var pricePromotion = algorithm;
    var listPromotion = algorithm
      ? { basePriceCents: algorithm.basePriceCents }
      : null;
    var priceSource = algorithm ? 'deal-wave' : 'none';
    var cart = this.cartDiscount;
    var exactCart = null;
    var conditionalMessage = '';

    if (cart) {
      if (cart.minimum && cart.minimum.type === 'quantity' && quantity < Number(cart.minimum.value)) {
        conditionalMessage = 'Sepette %' + percentage(cart.value) + ' indirim için en az ' + cart.minimum.value + ' adet gerekir.';
      } else if (cart.minimum && cart.minimum.type === 'subtotal' && currentTotal < Math.round(Number(cart.minimum.value) * 100)) {
        conditionalMessage = 'Uygun sepet koşullarında ekstra %' + percentage(cart.value) + ' indirim uygulanır.';
      } else {
        exactCart = calculateDiscountedCents(currentTotal, cart.value);
      }
    }

    var state = algorithm && exactCart != null
      ? 'both'
      : algorithm
        ? 'algorithm_only'
        : exactCart != null
          ? 'cart_only'
          : 'none';
    var cartState = exactCart != null
      ? 'exact'
      : conditionalMessage
        ? 'conditional'
        : this.eligibilityState === 'error'
          ? 'verification-error'
          : this.eligibilityState === 'checking'
            ? 'checking'
            : 'none';
    this.nodes.pricing.dataset.discountState = state;
    this.nodes.pricing.dataset.priceSource = priceSource;
    this.nodes.pricing.dataset.cartState = cartState;
    this.root.dataset.discountState = state;
    this.root.dataset.priceDiscountSource = priceSource;
    this.root.dataset.cartDiscountState = cartState;

    var couponDisplay = qualifiedCouponDisplay(variant, quantity, this.config.currency, cart, Date.now());
    var displayUnitCents = couponDisplay ? couponDisplay.unitCents : variant.priceCents;
    var displayLabel = couponDisplay ? couponDisplay.label : 'Bugünkü fiyat';
    this.nodes.pricing.dataset.couponDisplay = couponDisplay ? 'qualified-conditional' : 'none';
    this.nodes.sku.textContent = variant.sku || '—';
    this.nodes.currentLabel.textContent = displayLabel + ' · ' + (variant.title || 'Seçili ebat');
    this.nodes.currentPrice.textContent = money(displayUnitCents);
    setHidden(this.nodes.listMetric, !listPromotion);
    setHidden(this.nodes.listLabel, !listPromotion);
    setHidden(this.nodes.listPrice, !listPromotion);
    if (listPromotion) {
      this.nodes.listLabel.textContent = 'Kampanya öncesi fiyat';
      this.nodes.listPrice.textContent = money(listPromotion.basePriceCents);
    } else {
      this.nodes.listLabel.textContent = '';
      this.nodes.listPrice.textContent = '';
    }

    if (this.nodes.savingLabel) this.nodes.savingLabel.textContent = couponDisplay && pricePromotion ? 'Fırsat kazancınız' : 'Kazancınız';
    setHidden(this.nodes.savingMetric, !pricePromotion);
    if (pricePromotion && this.nodes.savingAmount && this.nodes.savingPercent) {
      var savingCents = Math.max(0, algorithm.basePriceCents - variant.priceCents);
      this.nodes.savingAmount.textContent = money(savingCents);
      this.nodes.savingPercent.textContent = '%' + percentage(pricePromotion.percent);
      setHidden(this.nodes.savingSeparator, false);
    } else {
      if (this.nodes.savingAmount) this.nodes.savingAmount.textContent = '';
      if (this.nodes.savingPercent) this.nodes.savingPercent.textContent = '';
      setHidden(this.nodes.savingSeparator, true);
    }

    setHidden(this.nodes.dealBadge, !pricePromotion);
    this.nodes.dealBadge.classList.toggle('dv-fixed-option3__badge--deal', Boolean(algorithm));
    this.nodes.dealBadge.classList.toggle('dv-fixed-option3__badge--product', false);
    if (pricePromotion) {
      this.nodes.dealBadge.textContent = '%' + percentage(pricePromotion.percent) + ' Fırsat indirimi';
      this.nodes.dealBadge.dataset.discountSource = priceSource;
    } else {
      this.nodes.dealBadge.removeAttribute('data-discount-source');
      this.nodes.dealBadge.textContent = '';
    }
    if (this.nodes.campaignEnd) {
      var endText = campaignEndText(algorithm, Date.now());
      this.nodes.campaignEnd.textContent = endText;
      setHidden(this.nodes.campaignEnd, !endText);
    }
    this.renderPriceProof(variant, Date.now());
    setHidden(this.nodes.cartBadge, exactCart == null);
    if (exactCart != null) {
      this.nodes.cartBadge.textContent = pricePromotion
        ? 'Sepette ekstra %' + percentage(cart.value)
        : 'Sepette %' + percentage(cart.value) + ' indirim';
    }
    setHidden(this.nodes.badges, !pricePromotion && exactCart == null);

    setHidden(this.nodes.stackNote, !(pricePromotion && (exactCart != null || couponDisplay)));
    if (pricePromotion && couponDisplay) {
      this.nodes.stackNote.textContent = 'Fırsat fiyatı ' + money(variant.priceCents) + '; kuponla sepette ' + money(displayUnitCents) + '. Kupon indirimi fırsat fiyatı üzerinden hesaplanır.';
    }
    if (pricePromotion && exactCart != null) {
      this.nodes.stackNote.textContent = 'Sepette ekstra %' + percentage(cart.value) + ' indirim, fırsat fiyatı olan ' + money(variant.priceCents) + ' üzerinden uygulanır.';
    }

    setHidden(this.nodes.cartResult, exactCart == null);
    if (exactCart != null) {
      var baseTotal = listPromotion ? listPromotion.basePriceCents * quantity : currentTotal;
      var cartExtra = currentTotal - exactCart;
      var totalSaving = baseTotal - exactCart;
      this.nodes.cartTotal.textContent = money(exactCart);
      this.nodes.cartExtra.textContent = 'Sepette ' + money(cartExtra) + ' daha';
      this.nodes.totalSaving.textContent = 'Toplam avantaj ' + money(totalSaving);
    }

    if (couponDisplay) conditionalMessage = couponDisplay.condition;
    setHidden(this.nodes.conditional, !conditionalMessage);
    this.nodes.conditional.textContent = conditionalMessage;

    var showVerification = this.eligibilityState === 'checking' || this.eligibilityState === 'error';
    setHidden(this.nodes.cartVerification, !showVerification);
    if (this.nodes.cartVerificationMessage) {
      this.nodes.cartVerificationMessage.textContent = this.eligibilityState === 'error'
        ? 'Sepet indirimi şu an doğrulanamadı.'
        : this.eligibilityState === 'checking'
          ? 'Sepet indirimi doğrulanıyor…'
          : '';
    }
    setHidden(this.nodes.cartRetry, this.eligibilityState !== 'error');

    var stickyTotal = couponDisplay ? couponDisplay.totalCents : exactCart != null ? exactCart : currentTotal;
    if (this.nodes.installmentMonthly) {
      this.nodes.installmentMonthly.textContent = money(Math.round(stickyTotal / 6));
      this.nodes.installments.dataset.installmentTotalCents = String(stickyTotal);
    }
    if (this.nodes.priceInstallment) {
      this.nodes.priceInstallment.textContent = money(Math.round(stickyTotal / 6));
    }
    if (this.nodes.sizeTitle) this.nodes.sizeTitle.textContent = variant.title || 'Seçili ebat';
    if (this.nodes.sizeStock) {
      this.nodes.sizeStock.textContent = variant.available === true ? 'Stokta' : 'Tükendi';
      this.nodes.sizeStock.dataset.stockState = variant.available === true ? 'in' : 'out';
    }
    if (this.nodes.stickySize) {
      this.nodes.stickySize.textContent = variant.title || 'Seçili ebat';
      var stickyPrefix = this.nodes.stickySize.previousSibling;
      if (stickyPrefix && stickyPrefix.nodeType === 3) {
        stickyPrefix.nodeValue = (couponDisplay ? couponDisplay.label : 'Ölçü') + ' · ';
      }
    }
    setHidden(this.nodes.stickyDeal, !algorithm);
    if (algorithm) {
      if (this.nodes.stickyListPrice) this.nodes.stickyListPrice.textContent = money(algorithm.basePriceCents);
      if (this.nodes.stickyDiscount) this.nodes.stickyDiscount.textContent = '%' + percentage(algorithm.percent) + (couponDisplay ? ' Fırsat' : ' indirim');
    } else {
      if (this.nodes.stickyListPrice) this.nodes.stickyListPrice.textContent = '';
      if (this.nodes.stickyDiscount) this.nodes.stickyDiscount.textContent = '';
    }
    if (this.nodes.stickyPrice) this.nodes.stickyPrice.textContent = money(displayUnitCents);
    if (this.nodes.stickySummary) {
      var stickyLabel = 'Seçili ölçü ' + (variant.title || 'Seçili ebat') + '. ';
      if (algorithm) {
        stickyLabel += 'Kampanya öncesi fiyat ' + money(algorithm.basePriceCents) + ', yüzde ' + percentage(algorithm.percent) + (couponDisplay ? ' fırsat indirimi; fırsat fiyatı ' + money(variant.priceCents) + '. ' : ' indirim. ');
      }
      stickyLabel += displayLabel + ' ' + money(displayUnitCents) + '.';
      if (couponDisplay) stickyLabel += ' ' + couponDisplay.condition;
      if (this.nodes.sizeToggle) stickyLabel += ' Ölçüyü değiştirmek için açın.';
      this.nodes.stickySummary.setAttribute('aria-label', stickyLabel);
    }

    if (this.nodes.buyButton) {
      this.nodes.buyButton.dataset.dvCouponDisplay = couponDisplay ? 'true' : 'false';
      if (couponDisplay) ensureCouponCtaStyle();
    }
    var unavailable = variant.available !== true;
    var soldOut = unavailable || (this.nodes.buyButton && this.nodes.buyButton.disabled);
    this.nodes.stickyButton.disabled = Boolean(soldOut || this.submitLocked);
    this.nodes.stickyButton.textContent = soldOut ? 'Tükendi' : this.submitLocked ? 'Ekleniyor…' : 'Sepete ekle';
    if (this.nodes.stickyButton) setHidden(this.nodes.stickyButton, unavailable);
    if (this.nodes.stickyAlert) {
      this.nodes.stickyAlert.classList.toggle('is-primary', unavailable);
      this.nodes.stickyAlert.textContent = unavailable ? 'Stok gelince haber ver' : 'Fiyat alarmı';
    }
    if (this.nodes.stickyActions) this.nodes.stickyActions.dataset.stockState = unavailable ? 'out' : 'in';
    if (this.buyText && !soldOut && !this.submitLocked) {
      this.buyText.textContent = exactCart != null
        ? 'Sepete ekle · Sepette ' + money(exactCart)
        : 'Sepete ekle';
    }

    this.root.dispatchEvent(new CustomEvent('dv:option3:rendered', {
      bubbles: true,
      detail: {
        state: state,
        variantId: variant.id,
        quantity: quantity,
        priceSource: priceSource,
        cartState: cartState,
        currentTotalCents: currentTotal,
        cartTotalCents: exactCart
      }
    }));
  };

  Option3.prototype.markEligibilityError = function () {
    this.cartDiscount = null;
    this.eligibilityState = 'error';
    this.render();
  };

  function fetchEligibilityDecision(url, signal) {
    var retryIndex = 0;

    function request() {
      if (signal && signal.aborted) {
        var aborted = new Error('eligibility_aborted');
        aborted.name = 'AbortError';
        return Promise.reject(aborted);
      }
      return fetch(url, {
        method: 'GET',
        credentials: 'omit',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: signal || undefined
      }).then(function (response) {
        if (!response.ok) throw new Error('eligibility_http_' + response.status);
        return response.json();
      }).catch(function (error) {
        if ((signal && signal.aborted) || retryIndex >= ELIGIBILITY_RETRY_DELAYS_MS.length) {
          throw error;
        }
        var delay = ELIGIBILITY_RETRY_DELAYS_MS[retryIndex++];
        return new Promise(function (resolve) {
          window.setTimeout(resolve, delay);
        }).then(request);
      });
    }

    return request();
  }

  Option3.prototype.loadEligibility = function (variant, options) {
    options = options || {};
    var endpoint = String(this.root.dataset.discountEligibilityUrl || '');
    if (!variant || !variant.id) return;
    if (!endpoint || typeof fetch !== 'function') {
      this.markEligibilityError();
      return;
    }
    var cached = this.eligibilityCache.get(variant.id);
    if (options.force !== true && cached && Date.parse(cached.validUntil || '') > Date.now()) {
      this.applyEligibility(cached);
      return;
    }
    if (this.eligibilityRequest && this.eligibilityRequest.abort) this.eligibilityRequest.abort();
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    this.eligibilityRequest = controller;
    var sequence = ++this.eligibilitySequence;
    var url;
    try {
      url = new URL(endpoint, window.location.origin);
      url.searchParams.set('handle', this.root.dataset.productHandle || '');
      url.searchParams.set('variantId', variant.id);
    } catch (_) {
      this.markEligibilityError();
      return;
    }
    var self = this;
    this.cartDiscount = null;
    this.eligibilityState = 'checking';
    this.render();
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, ELIGIBILITY_REQUEST_TIMEOUT_MS);
    fetchEligibilityDecision(url.toString(), controller ? controller.signal : null)
    .then(function (decision) {
      if (sequence !== self.eligibilitySequence || !self.variant || self.variant.id !== variant.id) return;
      if (self.applyEligibility(decision)) self.eligibilityCache.set(variant.id, decision);
    }).catch(function () {
      if (sequence !== self.eligibilitySequence || !self.variant || self.variant.id !== variant.id) return;
      self.markEligibilityError();
    }).finally(function () {
      window.clearTimeout(timer);
      if (sequence === self.eligibilitySequence) self.eligibilityRequest = null;
    });
  };

  Option3.prototype.applyEligibility = function (decision) {
    var now = Date.now();
    var discount = validCartDecision(decision, now);
    if (!discount && !validNoCartDecision(decision, now)) {
      this.markEligibilityError();
      return false;
    }
    this.cartDiscount = discount;
    this.eligibilityState = discount ? 'verified' : 'verified-none';
    this.render();
    return true;
  };

  Option3.prototype.lockSubmission = function () {
    var self = this;
    this.submitLocked = true;
    this.render();
    window.clearTimeout(this.submitTimer);
    this.submitTimer = window.setTimeout(function () { self.unlockSubmission(); }, 2200);
  };

  Option3.prototype.unlockSubmission = function () {
    this.submitLocked = false;
    window.clearTimeout(this.submitTimer);
    this.render();
  };

  function mount(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (mounted.has(root)) return;
      var instance = new Option3(root);
      mounted.set(root, instance);
      instance.init();
    });
  }

  window.DvFixedProductOption3 = {
    mount: mount,
    money: money,
    calculateDiscountedCents: calculateDiscountedCents,
    campaignEndText: campaignEndText,
    validAlgorithm: validAlgorithm,
    priceProofModel: priceProofModel,
    validCartDecision: validCartDecision,
    getInstance: function (root) { return mounted.get(root); }
  };

  if (document.readyState === 'loading') {
    ensureAiRoomModalRepair();
    document.addEventListener('DOMContentLoaded', function () {
      mount(document);
      ensureAiRoomModalRepair();
    });
  } else {
    mount(document);
    ensureAiRoomModalRepair();
  }
  document.addEventListener('shopify:section:load', function (event) {
    mount(event.target);
    ensureAiRoomModalRepair();
  });
}());
